<template>
  <div class="page-container">
    <header class="header">
      <button @click="handleBack" class="back-btn" aria-label="返回">
        <img src="@/assets/返回.svg" alt="返回" class="icon-back" />
      </button>
      <div class="header-center">
        <h1 class="title">收货</h1>
      </div>
      <div class="header-right">
        <el-select
          v-model="timeFilter"
          class="header-time-filter"
          @change="handleTimeFilterChange"
        >
          <el-option label="全部" value="" />
          <el-option label="半个月" value="lastHalfMonth" />
          <el-option label="一个月" value="lastMonth" />
        </el-select>
        <el-button
          class="create-btn"
          type="primary"
          @click="handleCreate"
          @touchend.prevent="handleCreate"
        >
          新增
        </el-button>
      </div>
    </header>

    <main class="content" @click="closeSupplierDropdown">
      <el-segmented
        v-model="activeTab"
        :options="tabOptions"
        @change="handleTabChange"
        block
        class="tabs-segment"
      />

      <div
        v-if="messageVisible"
        class="message-overlay"
        @click="messageVisible = false"
      >
        <div class="message-modal" @click.stop>
          <div class="message-icon" :class="messageType">
            {{
              messageType === "success"
                ? "✓"
                : messageType === "error"
                ? "✗"
                : "!"
            }}
          </div>
          <div class="message-text">{{ messageText }}</div>
          <el-button
            type="primary"
            size="large"
            round
            @click="messageVisible = false"
            class="message-btn"
          >
            确定
          </el-button>
        </div>
      </div>

      <div class="supplier-search-row" @click.stop>
        <el-tooltip
          content="排序方式"
          placement="top"
          effect="dark"
          :show-after="300"
          trigger="hover"
        >
          <div class="sort-filter-wrap">
            <el-select
              v-model="sortField"
              class="sort-filter-select"
              @change="handleSortFieldChange"
            >
              <el-option label="按编码" value="materialNo" />
              <el-option label="创建时间" value="createTime" />
              <el-option label="入库时间" value="wareInTime" />
            </el-select>
          </div>
        </el-tooltip>
        <el-tooltip
          content="单据类型"
          placement="top"
          effect="dark"
          :show-after="300"
          trigger="hover"
        >
          <div class="type-filter-wrap">
            <el-select
              v-model="wareInTypeFilter"
              class="supplier-search-select"
              @change="handleTypeFilterChange"
            >
              <el-option label="全部" value="" />
              <el-option label="收货入库" value="0" />
              <el-option label="退货入库" value="1" />
            </el-select>
          </div>
        </el-tooltip>
        <el-select
          v-model="selectedSupplierId"
          class="supplier-search-input"
          placeholder="请输入供应商名称搜索"
          filterable
          remote
          :remote-method="handleSupplierSearch"
          :loading="supplierLoading"
          clearable
          @clear="clearSelectedSupplier"
          @change="handleSupplierChange"
        >
          <el-option
            v-for="s in supplierList"
            :key="s.id"
            :label="s.supplierName"
            :value="s.id"
          />
        </el-select>
      </div>

      <div class="no-search">
        <div class="no-search-row">
          <el-tooltip
            content="搜索类型"
            placement="top"
            effect="dark"
            :show-after="300"
            trigger="hover"
          >
            <div class="no-search-type-wrap">
              <el-select
                v-model="noSearchType"
                class="no-search-select"
                @change="handleNoSearchTypeChange"
              >
                <el-option label="PLS单号" value="receiptNo" />
                <el-option label="入库单号" value="wareInNo" />
                <el-option label="物料编码" value="materialNo" />
              </el-select>
            </div>
          </el-tooltip>
          <el-input
            v-model="noKeyword"
            class="no-search-input"
            :placeholder="getNoSearchPlaceholder()"
            @keyup.enter="handleNoSearch"
            clearable
            @clear="clearNoSearch"
          />
        </div>
        <div v-if="hasMultipleKeywords" class="no-search-hint">
          已输入 {{ keywordCount }} 个编码，按空格分隔
        </div>
      </div>

      <div v-if="statusMsg" class="status-banner" :class="statusType">
        {{ statusMsg }}
      </div>

      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p class="loading-text">加载中...</p>
      </div>

      <div v-else>
        <div v-if="list.length === 0" class="empty-state">
          <img src="@/assets/无数据.svg" alt="暂无数据" class="empty-img" />
          <p class="empty-text">~ 暂无数据 ~</p>
        </div>

        <div v-else class="card-list">
          <div
            class="data-card"
            v-for="item in list"
            :key="item.id || item.wareInId || item.wareInNo"
          >
            <button
              v-if="canRemoveCard"
              class="card-remove-btn"
              type="button"
              :disabled="isRemoving(item)"
              :aria-label="isRemoving(item) ? '删除中' : '删除单据'"
              @click="handleRemoveWareIn(item, $event)"
            >
              {{ isRemoving(item) ? "…" : "×" }}
            </button>
            <div class="receive-card-header">
              <div class="receive-card-header-left">
                <div class="receive-type-row">
                  <input
                    v-if="
                      activeTab === 'pending' &&
                      (item.wareInType === 1 || item.wareInType === '1')
                    "
                    type="checkbox"
                    class="card-checkbox"
                    :checked="selectedIds.includes(getWareInId(item))"
                    :disabled="
                      (selectedIds.length >= 10 &&
                        !selectedIds.includes(getWareInId(item))) ||
                      !canSelectReturnItem(item) ||
                      (selectedSupplierName &&
                        item.supplierName !== selectedSupplierName)
                    "
                    @change="toggleSelect(item)"
                  />
                  <div
                    class="receive-type"
                    :class="getWareInTypeClass(item.wareInType)"
                  >
                    {{ getWareInTypeText(item.wareInType) }}
                  </div>
                  <div v-if="isReturnBad(item)" class="receive-bad-tag">
                    不良
                  </div>
                  <div v-else-if="isReturnGood(item)" class="receive-good-tag">
                    良品
                  </div>
                  <button
                    v-if="
                      activeTab === 'pending' &&
                      (isReturnBad(item) || isReturnGood(item))
                    "
                    class="toggle-bad-btn"
                    @click="handleToggleBad(item)"
                  >
                    {{ isReturnBad(item) ? "改为良品" : "改为不良品" }}
                  </button>
                  <span
                    v-if="formatDate(item.createTime)"
                    class="receive-create-time"
                  >
                    {{ formatDate(item.createTime) }}
                  </span>
                </div>
                <div class="receive-no">
                  {{ item.receiptNo ? "PLS单号" : "入库单号" }}：{{
                    item.receiptNo || item.wareInNo || "-"
                  }}
                </div>
              </div>
            </div>

            <div class="receive-card-body">
              <div class="receive-grid">
                <div class="receive-field">
                  <div class="receive-label">入库单号</div>
                  <div class="receive-value">{{ item.wareInNo || "-" }}</div>
                </div>
                <div class="receive-field">
                  <div class="receive-label">供应商</div>
                  <div class="receive-value">
                    {{ item.supplierName || "-" }}
                  </div>
                </div>
                <div class="receive-field">
                  <div class="receive-label">物料编码</div>
                  <div class="receive-value receive-material-value">
                    <span class="receive-material-no">{{ getMaterialNoDisplay(item) }}</span>
                    <span
                      v-if="hasMultiVersion(item)"
                      class="multi-version-badge"
                      title="该物料存在多版本"
                    >多版本</span>
                    <el-button
                      v-if="hasMultiVersion(item)"
                      size="small"
                      type="warning"
                      plain
                      round
                      class="version-edit-btn"
                      @click.stop="openVersionSelectFromList(item)"
                    >
                      修改子版本
                    </el-button>
                  </div>
                </div>
                <div class="receive-field">
                  <div class="receive-label">入库数量</div>
                  <div class="receive-value">
                    {{ formatQty(getTotalWareInNum(item) ?? "-") }}
                  </div>
                </div>
                <div v-if="item.wareInTime" class="receive-field">
                  <div class="receive-label">入库时间</div>
                  <div class="receive-value">
                    {{ item.wareInTime }}
                  </div>
                </div>
                <div
                  v-if="String(item.failDesc || '').trim()"
                  class="receive-field receive-fail-field"
                >
                  <div
                    class="fail-desc-header"
                    @click="
                      failDescExpanded[getWareInId(item)] =
                        !failDescExpanded[getWareInId(item)]
                    "
                  >
                    <span class="receive-label">入库失败原因</span>
                    <span
                      class="fail-desc-toggle"
                      :class="{ expanded: failDescExpanded[getWareInId(item)] }"
                    >
                      ▼
                    </span>
                  </div>
                  <div
                    class="fail-desc-content-wrap"
                    v-show="failDescExpanded[getWareInId(item)]"
                  >
                    <div class="receive-value receive-fail-value">
                      {{ item.failDesc }}
                    </div>
                  </div>
                  <div
                    v-show="!failDescExpanded[getWareInId(item)]"
                    class="receive-value receive-fail-value truncated"
                  >
                    {{ item.failDesc }}
                  </div>
                </div>
              </div>

              <div class="receive-btn-group" v-if="activeTab === 'pending'">
                <el-button
                  type="primary"
                  :loading="receiveLoading"
                  @click="openReceiveDetail(item)"
                >
                  多物料收货
                </el-button>
                <el-button
                  :loading="receiveLoading"
                  :class="{ 'is-multi-version-disabled': hasMultiVersion(item) }"
                  @click="openSingleReceive(item)"
                >
                  单物料收货
                </el-button>
                <el-button
                  type="warning"
                  :loading="multiPalletLoadingId === item.id"
                  @click="openMultiMaterialMultiPallet(item)"
                >
                  {{
                    multiPalletLoadingId === item.id
                      ? "加载中..."
                      : "多物料多托盘"
                  }}
                </el-button>
              </div>
              <el-button
                v-else-if="activeTab === 'todo'"
                type="primary"
                class="light-btn"
                @click="handleDistribute(item, $event)"
              >
                分配
              </el-button>
              <el-button
                v-else-if="activeTab === 'done'"
                 :disabled="ture"
                type="danger"
                
                @click="openRedash(item)"
              >
                红冲
              </el-button>
            </div>
          </div>

          <div class="list-footer">
            <div class="page-info">
              第 {{ current }} / {{ totalPages }} 页，共 {{ total }} 条
            </div>
            <div class="page-actions">
              <el-button
                round
                :disabled="current <= 1 || loading"
                :loading="loading && current > 1"
                @click="goPrevPage"
              >
                上一页
              </el-button>
              <el-button
                type="primary"
                round
                :disabled="current >= totalPages || loading"
                :loading="loading && current < totalPages"
                @click="goNextPage"
              >
                下一页
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="activeTab === 'pending' && selectedIds.length > 0"
        class="batch-action-bar"
      >
        <el-button
          size="small"
          round
          @click="toggleSelectAll"
          :disabled="loading"
        >
          {{ isAllSelected ? "取消全选" : "全选" }}
        </el-button>
        <div class="batch-select-info" @click="openSelectedSummary">
          已选择 {{ selectedIds.length }} 条
        </div>
        <el-button
          type="primary"
          round
          :disabled="selectedIds.length === 0"
          @click="handleBatchReceive"
        >
          批量入库
        </el-button>
      </div>
    </main>

    <!-- 托盘码扫码组件 -->
    <CameraScan
      v-model:visible="palletScanVisible"
      title="扫描托盘码"
      @success="handleScanSuccess"
      @close="palletScanVisible = false"
    />

    <div
      v-if="selectedSummaryVisible"
      class="summary-overlay"
      @click="closeSelectedSummary"
    >
      <div class="summary-sheet" @click.stop>
        <div class="summary-header">
          <div class="summary-title">已选择单据物料汇总</div>
          <div class="summary-total-qty">
            总数量：{{ formatQty(totalMaterialQty) }}
          </div>
          <button class="summary-close" @click="closeSelectedSummary">×</button>
        </div>
        <div class="summary-body">
          <div
            v-if="selectedMaterialSummary.length === 0"
            class="summary-empty"
          >
            暂无数据
          </div>
          <div v-else class="summary-list">
            <div class="summary-row summary-row-head">
              <div class="summary-col-material">物料编码</div>
              <div class="summary-col-qty">数量</div>
            </div>
            <div
              v-for="(item, idx) in selectedMaterialSummary"
              :key="idx"
              class="summary-row"
            >
              <div class="summary-col-material">{{ item.materialNo }}</div>
              <div class="summary-col-qty">{{ formatQty(item.totalQty) }}</div>
            </div>
          </div>
        </div>
        <div class="summary-footer">
          <el-button
            type="primary"
            size="large"
            round
            @click="closeSelectedSummary"
            class="summary-confirm-btn"
          >
            关闭
          </el-button>
        </div>
      </div>
    </div>

    <div v-if="detailVisible" class="detail-overlay" @click.self="closeDetail">
      <div class="detail-sheet">
        <div class="detail-header">
          <button class="detail-back" @click="closeDetail" aria-label="返回">
            <img src="@/assets/返回.svg" alt="返回" class="detail-back-icon" />
          </button>
          <div class="detail-title">待收货</div>
          <div class="detail-header-right"></div>
        </div>

        <div class="detail-body">
          <div v-if="detailLoading" class="detail-loading">加载中...</div>
          <div v-else-if="detailError" class="detail-error">
            {{ detailError }}
          </div>
          <div v-else class="detail-content">
            <div class="detail-section">
              <div class="detail-row">
                <div class="detail-label">入库单号</div>
                <div class="detail-value">
                  {{ detailData?.wareInNo || "-" }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">创建时间</div>
                <div class="detail-value">
                  {{ formatTime(detailData?.createTime) }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">供应商</div>
                <div class="detail-value">
                  {{ detailData?.supplierName || "-" }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">入库类型</div>
                <div class="detail-value">
                  {{ getWareInTypeText(detailData?.wareInType) }}
                </div>
              </div>
            </div>

            <div class="detail-section-title">物料信息</div>
            <div class="detail-section">
              <template v-if="(detailData?.wareInDetailList || []).length">
                <div
                  v-for="m in detailData?.wareInDetailList || []"
                  :key="m.id"
                  class="detail-section"
                >
                  <div class="detail-row">
                    <div class="detail-label">物料编码</div>
                    <div class="detail-value detail-material-no">
                      <span class="detail-material-text">{{ m?.materialNo || "-" }}</span>
                      <span
                        v-if="isDetailMultiVersion"
                        class="multi-version-badge"
                        title="该物料存在多版本"
                      >多版本</span>
                      <el-button
                        v-if="isDetailMultiVersion"
                        size="small"
                        type="warning"
                        plain
                        round
                        class="version-edit-btn"
                        :loading="versionLoadingId === (m.materialId || m.id)"
                        @click="openVersionSelect(m)"
                      >
                        修改子版本
                      </el-button>
                    </div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">物料描述</div>
                    <div class="detail-value">{{ m?.materialDesc || "-" }}</div>
                  </div>
                  <div class="detail-row">
                    <div class="detail-label">来货数量</div>
                    <div class="detail-value">
                      {{ formatQty(m?.comeNum || "-")
                      }}{{ m?.packageUnitName || "" }}
                    </div>
                  </div>

                  <div class="detail-actions">
                    <el-button
                      type="primary"
                      round
                      class="light-btn"
                      :loading="isOpening(m.id)"
                      :class="{
                        'is-multi-version-disabled':
                          isDetailMultiVersion && !isMaterialDone(m),
                      }"
                      @click="openPalletPage(m)"
                    >
                      {{
                        isOpening(m.id)
                          ? "查询中..."
                          : isMaterialDone(m)
                          ? "归托详情"
                          : "扫码归托"
                      }}
                    </el-button>
                  </div>
                </div>
              </template>
              <div v-else class="detail-empty">暂无物料信息</div>
            </div>
          </div>
        </div>

        <div class="detail-footer">
          <el-button
            type="primary"
            size="large"
            round
            :loading="confirmSubmitting"
            :disabled="confirmSubmitting"
            @click="handleConfirmReceive"
            class="detail-finish-btn"
          >
            {{ confirmSubmitting ? "收货中" : "收货完成" }}
          </el-button>
        </div>
      </div>
    </div>

    <div
      v-if="palletVisible"
      class="detail-overlay"
      @click.self="closePalletPage"
    >
      <div class="detail-sheet">
        <div class="detail-header">
          <button
            class="detail-back"
            @click="closePalletPage"
            aria-label="返回"
          >
            <img src="@/assets/返回.svg" alt="返回" class="detail-back-icon" />
          </button>
          <div class="detail-title">
            {{
              collectType === 1
                ? "零头托"
                : palletReadonly
                ? "归托详情"
                : "扫码归托"
            }}
          </div>
          <div class="detail-header-right"></div>
        </div>

        <div class="detail-body">
          <div v-if="palletLoading" class="detail-loading">加载中...</div>
          <div v-else-if="palletError" class="detail-error">
            {{ palletError }}
          </div>
          <div v-else class="detail-content">
            <div class="detail-section">
              <div class="detail-row">
                <div class="detail-label">供应商</div>
                <div class="detail-value">
                  {{ detailData?.supplierName || "-" }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">PLS单号</div>
                <div class="detail-value">
                  {{ detailData?.receiptNo || "-" }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">入库单号</div>
                <div class="detail-value">
                  {{ detailData?.wareInNo || "-" }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">物料编码</div>
                <div class="detail-value">
                  {{ palletMaterial?.materialNo || "-" }}
                </div>
              </div>
              <div class="detail-row">
                <div class="detail-label">来货数量</div>
                <div class="detail-value">
                  {{ formatQty(palletMaterial?.comeNum || "-")
                  }}{{ palletMaterial?.packageUnitName || "" }}
                </div>
              </div>
              <template v-if="!palletInfoCollapsed">
                <div class="detail-row">
                  <div class="detail-label">物料描述</div>
                  <div class="detail-value">
                    {{ palletMaterial?.materialDesc || "-" }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">批次号</div>
                  <div class="detail-value">
                    {{ palletMaterial?.batchNo || detailData?.batchNo || "-" }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">包装单位</div>
                  <div class="detail-value">
                    {{ palletMaterial?.packageUnitName || "-" }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">包装数量</div>
                  <div class="detail-value">
                    {{ formatQty(palletMaterial?.packageNum || "-") }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">单托最大容量</div>
                  <div class="detail-value">
                    {{ formatQty(palletMaxQty)
                    }}{{ palletMaterial?.packageUnitName || "" }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">物料组</div>
                  <div class="detail-value">
                    {{ palletMaterial?.materialGroupName || "默认" }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">仓管员</div>
                  <div class="detail-value">
                    {{ palletMaterial?.wareKeeperName || "-" }}
                  </div>
                </div>
                <div class="detail-row">
                  <div class="detail-label">备料员</div>
                  <div class="detail-value">
                    {{ palletMaterial?.materialOperatorName || "-" }}
                  </div>
                </div>
              </template>
            </div>

            <div class="collapse-row" @click="togglePalletInfoCollapse">
              <div class="collapse-text">
                {{ palletInfoCollapsed ? "展开" : "收起" }}
              </div>
              <div class="collapse-arrow">
                {{ palletInfoCollapsed ? "v" : "^" }}
              </div>
            </div>

            <div class="pallet-info">
              <div class="pallet-info-text">
                托盘信息：<span class="pallet-info-red"
                  >单托最大容量{{ formatQty(palletMaxQty)
                  }}{{ palletMaterial?.packageUnitName || "" }}</span
                >
              </div>
              <button
                v-if="!palletReadonly && collectType !== 1"
                class="pallet-leftover-btn"
                type="button"
                @click="selectLeftover"
              >
                零头托
              </button>
              <el-button
                v-else-if="!palletReadonly"
                type="warning"
                size="small"
                round
                @click="cancelLeftover"
              >
                取消零头托
              </el-button>
            </div>

            <div
              v-if="collectType !== 1"
              class="pallet-remaining-hint"
              :class="{ done: remainingQty <= 0 }"
            >
              <template v-if="remainingQty > 0">
                剩余未归托：<span class="pallet-remaining-num"
                  >{{ formatQty(remainingQty)
                  }}{{ palletMaterial?.packageUnitName || "" }}</span
                >
              </template>
              <template v-else> 已全部归托 </template>
            </div>

            <div v-if="collectType === 1" class="pallet-scan-error">
              零头托模式：无需扫码，请选择一个托盘后点击底部“完成归托”提交。
            </div>

            <div v-if="existingPalletRecords.length" class="pallet-list">
              <div class="pallet-row pallet-row-head">
                <div class="pallet-col-code">托盘码</div>
                <div class="pallet-col-qty">数量</div>
                <div class="pallet-col-op">状态</div>
              </div>
              <div
                v-for="(r, idx) in existingPalletRecords"
                :key="(r.id || r.palletCode || '') + '-' + idx"
                class="pallet-row"
              >
                <div class="pallet-col-code">
                  <div class="pallet-item-text">{{ r.palletCode || "-" }}</div>
                </div>
                <div class="pallet-col-qty">
                  {{ formatQty(r.wareInNum || r.zeroNum || "-") }}
                </div>
                <div class="pallet-col-op">
                  <span
                    :class="
                      r.status === 1
                        ? 'pallet-status-done'
                        : r.status === 0
                        ? 'pallet-status-pending'
                        : ''
                    "
                  >
                    {{
                      r.status === 1
                        ? "已归托"
                        : r.status === 0
                        ? "待处理"
                        : "-"
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div
              class="pallet-actions"
              v-if="!palletReadonly && collectType !== 1"
            >
              <div class="pallet-input-row">
                <div class="pallet-code-wrap">
                  <el-select
                    ref="palletCodeInput"
                    v-model="palletCode"
                    class="pallet-code-select"
                    filterable
                    remote
                    reserve-keyword
                    allow-create
                    default-first-option
                    clearable
                    :remote-method="handlePalletCodeSearch"
                    :loading="palletSearchLoading"
                    placeholder="请扫描/输入托盘码"
                    @change="handlePalletSelectFromSearch"
                    @clear="clearPalletCodeSearch"
                    @visible-change="handlePalletSelectVisible"
                  >
                    <el-option
                      v-for="p in palletSearchOptions"
                      :key="p.id || p.palletCode"
                      :label="p.palletCode"
                      :value="p.palletCode"
                    />
                  </el-select>
                  <el-button
                    type="text"
                    class="scan-btn"
                    @click="startScan"
                    aria-label="扫码"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      width="20"
                      height="20"
                    >
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                        ry="2"
                      />
                      <path
                        d="M7 7h3v3H7zM14 7h3v3h-3zM7 14h3v3H7zM14 14h3v3h-3z"
                      />
                    </svg>
                  </el-button>
                </div>
                <el-input
                  v-model="palletQty"
                  type="number"
                  inputmode="decimal"
                  placeholder="数量"
                  class="pallet-qty-input"
                />
              </div>

              <div class="pallet-btn-row">
                <el-button
                  type="primary"
                  round
                  class="light-btn"
                  @click="openWareModal"
                >
                  查询供应商库位
                </el-button>
                <el-button
                  type="success"
                  round
                  class="light-btn"
                  @click="addPallet()"
                >
                  添加托盘
                </el-button>
              </div>

              <div v-if="scanError" class="pallet-scan-error">
                {{ scanError }}
              </div>
              <input
                ref="palletFileInput"
                class="pallet-file"
                type="file"
                accept="image/jpeg,image/png"
                capture="environment"
                @change="handlePalletFileChange"
              />
              <div id="pallet-scan-file-region" class="scan-hidden"></div>
            </div>

            <div
              v-if="!palletReadonly && collectType === 1"
              class="pallet-list"
            >
              <div class="pallet-row pallet-row-head">
                <div class="pallet-col-code">托盘码</div>
                <div class="pallet-col-qty">数量</div>
                <div class="pallet-col-op">选择</div>
              </div>
              <div
                v-for="(r, idx) in leftoverStockList"
                :key="(r.palletId || r.palletCode || '') + '-' + idx"
                class="pallet-row"
                @click="selectLeftoverPallet(r)"
              >
                <div class="pallet-col-code">
                  <div class="pallet-item-text">
                    {{ r.storeName || "-" }} {{ r.palletCode || "-" }}
                  </div>
                </div>
                <div class="pallet-col-qty">{{ formatQty(r.stockNum) }}</div>
                <div class="pallet-col-op">
                  <div
                    class="pallet-radio"
                    :class="{
                      checked:
                        normalizePalletCode(r.palletCode || '') ===
                        normalizePalletCode(leftoverSelected?.palletCode || ''),
                    }"
                  >
                    ✓
                  </div>
                </div>
              </div>
              <div v-if="!leftoverStockList.length" class="detail-empty">
                暂无可用托盘
              </div>
            </div>

            <div
              v-if="collectType !== 1 && palletItems.length"
              class="pallet-list"
            >
              <div class="pallet-row pallet-row-head">
                <div class="pallet-col-code">托盘码</div>
                <div class="pallet-col-qty">数量</div>
                <div class="pallet-col-op">操作</div>
              </div>
              <div
                v-for="(p, idx) in palletItems"
                :key="p.code + '-' + idx"
                class="pallet-row"
              >
                <div class="pallet-col-code">
                  <div class="pallet-item-text">{{ p.code }}</div>
                </div>
                <div class="pallet-col-qty">{{ formatQty(p.qty) }}</div>
                <div class="pallet-col-op">
                  <el-button
                    type="danger"
                    text
                    size="small"
                    @click="removePallet(idx)"
                  >
                    删除
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-footer" v-show="!keyboardVisible">
          <el-button
            type="primary"
            size="large"
            round
            :loading="collectSubmitting"
            :disabled="palletReadonly"
            @click="handleFinishCollect"
            class="detail-finish-btn"
          >
            {{ collectSubmitting ? "归托中" : "完成归托" }}
          </el-button>
        </div>

        <div
          v-show="cameraVisible"
          class="camera-overlay"
          @click.self="stopMobileScan"
        >
          <div class="camera-sheet">
            <div class="camera-header">
              <div class="camera-title">手机扫码</div>
              <button
                class="camera-close"
                type="button"
                @click="stopMobileScan"
              >
                关闭
              </button>
            </div>
            <div id="pallet-scan-region" class="camera-video"></div>
            <div class="camera-tip">对准托盘条码/二维码</div>
            <div v-if="scanError" class="camera-error">{{ scanError }}</div>
            <div class="camera-actions">
              <el-button type="info" round @click="openPhotoScan">
                拍照扫码
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="wareModalVisible"
      class="modal-overlay"
      @click.self="closeWareModal"
    >
      <div class="ware-modal">
        <div class="ware-modal-header">
          <div class="ware-modal-title">供应商库位</div>
          <button
            class="ware-modal-close"
            @click="closeWareModal"
            aria-label="关闭"
          >
            ×
          </button>
        </div>
        <div class="ware-modal-body">
          <div v-if="wareLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p class="loading-text">加载中...</p>
          </div>
          <div v-else-if="wareList.length === 0" class="empty-state">
            <p class="empty-text">暂无库位信息</p>
          </div>
          <div v-else class="ware-table-container">
            <table class="ware-table">
              <thead>
                <tr>
                  <th class="ware-th-name">库位名称</th>
                  <th class="ware-th-occupied">是否占用</th>
                  <th class="ware-th-stock">库存数量</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in wareList"
                  :key="item.wareNo"
                  :class="[
                    'ware-tr',
                    item.stockNum != null && item.stockNum > 0
                      ? 'ware-tr-occupied'
                      : 'ware-tr-free',
                  ]"
                >
                  <td class="ware-td-name">{{ item.wareName || "-" }}</td>
                  <td class="ware-td-occupied">
                    {{
                      item.stockNum != null && item.stockNum > 0
                        ? "占用"
                        : "空闲"
                    }}
                  </td>
                  <td class="ware-td-stock">
                    {{
                      item.stockNum != null && item.stockNum > 0
                        ? item.stockNum
                        : 0
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ware-modal-footer">
          <el-button
            type="primary"
            size="large"
            round
            @click="closeWareModal"
            class="ware-modal-close-btn"
          >
            关闭
          </el-button>
        </div>
      </div>
    </div>

    <div v-if="submitting" class="action-overlay">
      <div class="action-overlay-panel">
        <div class="loading-spinner"></div>
        <div class="action-overlay-text">提交中...</div>
      </div>
    </div>

    <div v-if="recognizing" class="action-overlay">
      <div class="action-overlay-panel">
        <div class="loading-spinner"></div>
        <div class="action-overlay-text">识别中...</div>
      </div>
    </div>

    <div v-if="scanSuccessVisible" class="scan-success-hint">
      {{ scanSuccessMsg }}
    </div>

    <div v-if="collectErrorVisible" class="collect-error-overlay">
      <div class="collect-error-panel">
        <div class="collect-error-title">提示</div>
        <div class="collect-error-msg">{{ collectErrorMsg }}</div>
        <el-button
          type="primary"
          size="large"
          round
          @click="closeCollectError"
          class="collect-error-btn"
        >
          确定
        </el-button>
      </div>
    </div>

    <div v-if="createVisible" class="modal-overlay" @click.self="closeCreate">
      <div class="modal-container">
        <div class="modal-header">
          <div class="modal-title">创建收货入库单</div>
          <button class="modal-close" @click="closeCreate" aria-label="关闭">
            ×
          </button>
        </div>

        <div class="modal-body">
          <div class="form-block">
            <div class="block-title">选择供应商</div>
            <div class="form-group">
              <el-input
                v-model="createSupplierKeyword"
                class="search-input"
                placeholder="请输入供应商名称搜索"
                @input="handleCreateSupplierSearch"
                @focus="createSupplierDropdown = true"
                clearable
                @clear="clearCreateSupplier"
              />
              <div v-if="createSupplierDropdown" class="dropdown-menu">
                <div v-if="createSupplierLoading" class="dropdown-loading">
                  加载中...
                </div>
                <div
                  v-else-if="createSupplierList.length === 0"
                  class="dropdown-empty"
                >
                  暂无数据
                </div>
                <div
                  v-else
                  v-for="s in createSupplierList"
                  :key="s.id"
                  class="dropdown-item"
                  @click="selectCreateSupplier(s)"
                >
                  {{ s.supplierName }}
                </div>
              </div>
            </div>
          </div>

          <div class="form-block" :class="{ disabled: !createSupplier }">
            <div class="block-title">选择仓库</div>
            <div class="form-group">
              <el-select
                v-model="createStoreId"
                class="select"
                :disabled="!createSupplier || createWareLoading"
                @change="handleCreateWareSelect"
                placeholder="请选择仓库"
              >
                <el-option
                  v-for="w in createWareList"
                  :key="w.id"
                  :label="w.wareName"
                  :value="w.id"
                />
              </el-select>
            </div>
          </div>

          <div
            class="form-block"
            :class="{ disabled: !createSupplier || !createStoreId }"
          >
            <div class="block-title-row">
              <div class="block-title">物料明细</div>
              <el-button
                type="primary"
                size="small"
                @click="openCreateMaterialModal"
                :disabled="!createSupplier || !createStoreId"
              >
                新增
              </el-button>
            </div>

            <div v-if="createDetails.length === 0" class="empty-selected">
              <div class="empty-selected-text">请点击“新增”选择物料</div>
            </div>
            <div v-else class="selected-list">
              <div
                class="selected-card"
                v-for="(d, idx) in createDetails"
                :key="d.materialId"
              >
                <div class="selected-card-header">
                  <div class="mono">{{ d.materialNo || "-" }}</div>
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    @click="removeCreateDetail(idx)"
                    aria-label="删除"
                  >
                    ×
                  </el-button>
                </div>
                <div class="selected-card-body">
                  <div class="selected-row">
                    <span class="label">物料描述</span>
                    <span class="value">{{ d.materialDesc || "-" }}</span>
                  </div>
                  <div class="selected-row selected-row-double">
                    <div class="selected-col">
                      <span class="label">当前库存</span>
                      <span class="value">{{
                        formatQty(d.goodStockNum ?? "0")
                      }}</span>
                    </div>
                    <div class="selected-col">
                      <span class="label">入库后库存</span>
                      <span class="value">{{ calcAfterCreateStock(d) }}</span>
                    </div>
                  </div>
                  <div class="selected-row">
                    <span class="label required">入库数量</span>
                    <el-input
                      type="number"
                      min="1"
                      step="1"
                      v-model="d.wareInNum"
                      placeholder="请输入"
                      @change="normalizeCreateQty(d)"
                    />
                  </div>
                  <div class="selected-row">
                    <span class="label">备注</span>
                    <el-input v-model="d.remark" placeholder="可选" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <el-button size="small" @click="handleCancelCreate"> 取消 </el-button>
          <el-button
            type="primary"
            size="small"
            @click="handleSubmitCreate"
            :disabled="!canSubmitCreate || createSubmitting"
          >
            {{ createSubmitting ? "保存中..." : "保存" }}
          </el-button>
        </div>
      </div>
    </div>

    <div
      v-if="createMaterialVisible"
      class="modal-overlay"
      @click.self="handleCreateMaterialCancel"
    >
      <div class="modal-container material-modal">
        <div class="modal-header">
          <div class="modal-title">选择物料</div>
          <button
            class="modal-close"
            @click="handleCreateMaterialCancel"
            aria-label="关闭"
          >
            ×
          </button>
        </div>

        <div class="modal-body material-modal-body">
          <div class="modal-list-head">
            <span class="modal-item-checkbox"></span>
            <span class="modal-item-no">物料编码</span>
            <span class="modal-item-stock-inline">当前库存</span>
          </div>
          <div class="modal-search">
            <el-input
              v-model="createMaterialKeyword"
              class="search-input"
              placeholder="搜索物料编码"
              clearable
              @input="handleCreateMaterialSearch"
              @clear="handleCreateMaterialSearch"
              @keyup.enter="handleCreateMaterialSearchEnter"
            />
          </div>
          <div v-if="createMaterialLoading" class="dropdown-loading">
            加载中...
          </div>
          <div
            v-else-if="createMaterialList.length === 0"
            class="dropdown-empty"
          >
            暂无数据
          </div>
          <div v-else class="modal-list">
            <div
              class="modal-item"
              v-for="m in createMaterialFilteredList"
              :key="m.id"
            >
              <el-checkbox
                :checked="isCreateAdded(m.id)"
                @change="toggleCreateMaterial(m)"
              />
              <div class="modal-item-main">
                <div class="modal-item-line">
                  <span class="mono modal-item-no">{{
                    truncateMaterialNo(m.materialNo) || "-"
                  }}</span>
                  <span class="modal-item-stock-inline">{{
                    m.goodStockNum ?? "0"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer material-modal-footer">
          <div class="material-modal-pagination">
            <el-button
              size="small"
              @click="changeCreateMaterialPage(-1)"
              :disabled="createMaterialCurrent <= 1"
            >
              上一页
            </el-button>
            <span class="mini-page"
              >{{ createMaterialCurrent }} /
              {{ createMaterialTotalPages }}</span
            >
            <el-button
              size="small"
              @click="changeCreateMaterialPage(1)"
              :disabled="createMaterialCurrent >= createMaterialTotalPages"
            >
              下一页
            </el-button>
          </div>
          <div class="material-modal-actions">
            <el-button size="small" @click="handleCreateMaterialCancel">
              取消
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="handleCreateMaterialConfirm"
            >
              确认
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="versionSelectVisible" class="modal-overlay" @click.self="closeVersionSelect">
      <div class="modal-container version-select-modal">
        <div class="modal-header">
          <div class="modal-title">选择子版本</div>
          <button class="modal-close" type="button" @click="closeVersionSelect" aria-label="关闭">
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class="version-parent-info">
            <div class="version-parent-no">{{ versionParentMaterial?.materialNo || "-" }}</div>
            <div class="version-parent-desc">{{ versionParentMaterial?.materialDesc || "" }}</div>
          </div>
          <div v-if="versionListLoading" class="dropdown-loading">加载中...</div>
          <div v-else-if="versionList.length === 0" class="empty-selected">
            <div class="empty-selected-text">暂无子版本物料</div>
          </div>
          <div v-else class="version-list">
            <button
              v-for="v in versionList"
              :key="v.id"
              type="button"
              class="version-item"
              :class="{ selected: selectedVersionId === String(v.id) }"
              @click="selectVersion(v)"
            >
              <div class="version-item-main">
                <div class="version-item-no">{{ v.materialNo || "-" }}</div>
                <div class="version-item-desc">{{ v.materialDesc || "-" }}</div>
              </div>
              <input
                class="version-radio"
                type="radio"
                :checked="selectedVersionId === String(v.id)"
                readonly
              />
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <el-button round @click="closeVersionSelect">取消</el-button>
          <el-button
            type="primary"
            round
            :disabled="!selectedVersion"
            :loading="versionSubmitting"
            @click="submitVersionSelect"
          >
            {{ versionSubmitting ? "提交中..." : "确认选择" }}
          </el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import {
  getWareInReceivePage,
  getWareInReceiveDetail,
  getWareInSupplierStockList,
  getWareInMaterialStockList,
  collectWareIn,
  confirmWareInCollect,
  distributeWareIn,
  removeWareIn,
  updateIsBad,
  getSupplierWare,
  getMaterialVersionList,
  updateWareInVersionFlag,
} from "@/api/wareInReceive";
import {
  getSupplierPageGtZero,
  getWareList,
  getMaterialPage,
  submitWareIn,
} from "@/api/wareInReceiveCreate";
import { getPalletCodeList } from "@/api/stockTransfer";
import { getUicAuthUserInfo } from "@/utils/auth";
import toast from "@/utils/toast";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import jsQR from "jsqr";
import { ElMessageBox } from "element-plus";
import CameraScan from "@/components/CameraScan";

export default {
  name: "WareInReceive",
  components: {
    CameraScan,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const keyboardVisible = ref(false);
    let viewportBaseHeight = 0;
    let removeViewportListener = null;
    let autoAddTimeout = null; // 自动添加的防抖定时器

    // 获取仓库设置
    const getWarehouseSettings = () => {
      try {
        let saved = null;
        // 尝试直接读取 localStorage
        try {
          saved = localStorage.getItem("warehouseSettings");
        } catch (e) {
          console.warn("🔧 无法访问 localStorage，使用默认设置", e);
        }

        if (saved) {
          const parsed = JSON.parse(saved);
          console.log("🔧 成功读取仓库设置:", parsed);
          return parsed;
        }
        // 默认开启自动添加
        console.log("🔧 未找到设置，默认开启自动添加托盘");
        return { autoAddPallet: true };
      } catch (e) {
        console.warn("🔧 读取设置出错，默认开启自动添加托盘", e);
        // 出错时默认开启自动添加
        return { autoAddPallet: true };
      }
    };

    const handleCreate = (e) => {
      if (e?.preventDefault) e.preventDefault();
      if (e?.stopPropagation) e.stopPropagation();
      openCreate();
    };

    const createVisible = ref(false);
    const createSupplierKeyword = ref("");
    const createSupplierLoading = ref(false);
    const createSupplierDropdown = ref(false);
    const createSupplierList = ref([]);
    const createSupplier = ref(null);
    const createSupplierTimer = ref(0);

    const messageVisible = ref(false);
    const messageText = ref("");
    const messageType = ref("info");

    const supplierKeyword = ref("");
    const supplierLoading = ref(false);
    const supplierDropdown = ref(false);
    const supplierList = ref([]);
    const selectedSupplier = ref(null);
    const selectedSupplierId = ref("");
    const wareInTypeFilter = ref("");
    const sortField = ref("materialNo");
    const timeFilter = ref("lastMonth");
    const supplierTimer = ref(0);

    // 单号搜索
    const noSearchType = ref("receiptNo"); // receiptNo | wareInNo | materialNo
    const noKeyword = ref("");

    const getNoSearchPlaceholder = () => {
      if (noSearchType.value === "receiptNo") return "请输入PLS单号搜索";
      if (noSearchType.value === "wareInNo") return "请输入入库单号搜索";
      return "请输入物料编码搜索";
    };

    const changeNoSearchType = (type) => {
      noSearchType.value = type;
      // 切换类型时，如果有搜索词则执行搜索
      if (noKeyword.value) {
        handleNoSearch();
      }
    };

    const handleNoSearchTypeChange = () => {
      // 切换下拉选项时，如果有搜索词则执行搜索
      if (noKeyword.value) {
        handleNoSearch();
      }
    };

    const handleNoSearch = async () => {
      await fetchPage({ resetPage: true });
    };

    const clearNoSearch = async () => {
      noKeyword.value = "";
      if (route.query?.noKeyword || route.query?.noSearchType) {
        const q = { ...route.query };
        delete q.noKeyword;
        delete q.noSearchType;
        router.replace({ query: q });
      }
      await fetchPage({ resetPage: true });
    };

    // 判断是否输入了多个编码（空格分隔）
    const hasMultipleKeywords = computed(() => {
      const kw = noKeyword.value?.trim();
      if (!kw) return false;
      return kw.split(/\s+/).filter(Boolean).length > 1;
    });

    // 计算编码数量
    const keywordCount = computed(() => {
      const kw = noKeyword.value?.trim();
      if (!kw) return 0;
      return kw.split(/\s+/).filter(Boolean).length;
    });

    const getSearchNoParams = () => {
      const kw = noKeyword.value?.trim();
      if (!kw) return {};

      // 支持空格分隔多个编码
      const keywords = kw.split(/\s+/).filter(Boolean);

      if (noSearchType.value === "receiptNo") {
        return keywords.length > 1
          ? { receiptNos: keywords.join(",") }
          : { receiptNo: kw };
      }
      if (noSearchType.value === "wareInNo") {
        return keywords.length > 1
          ? { wareInNos: keywords.join(",") }
          : { wareInNo: kw };
      }
      if (noSearchType.value === "materialNo") {
        return keywords.length > 1
          ? { materialNos: keywords.join(",") }
          : { materialNo: kw };
      }
      return {};
    };

    const createBizDept = ref("");
    const createWareLoading = ref(false);
    const createWareList = ref([]);
    const createStoreId = ref("");

    const createDetails = ref([]);

    const createMaterialVisible = ref(false);
    const createMaterialLoading = ref(false);
    const createMaterialKeyword = ref("");
    const createMaterialCurrent = ref(1);
    const createMaterialSize = ref(20);
    const createMaterialTotal = ref(0);
    const createMaterialList = ref([]);
    const createMaterialTimer = ref(0);
    let createMaterialReqSeq = 0;

    // 服务端按 materialNo 搜索，这里直接展示接口结果
    const createMaterialFilteredList = computed(() => createMaterialList.value);

    const createMaterialTotalPages = computed(() => {
      const total = createMaterialTotal.value || 0;
      const size = createMaterialSize.value || 20;
      return Math.max(1, Math.ceil(total / size));
    });

    const createSubmitting = ref(false);

    const canSubmitCreate = computed(() => {
      if (!createSupplier.value?.id) return false;
      if (!createStoreId.value) return false;
      if (createDetails.value.length === 0) return false;
      return createDetails.value.every((d) => Number(d.wareInNum) > 0);
    });

    const openCreate = async () => {
      if (!createBizDept.value) {
        const userInfo = getUicAuthUserInfo();
        createBizDept.value = userInfo?.deptId || "";
      }
      createVisible.value = true;
    };

    const closeCreate = () => {
      createVisible.value = false;
      createSupplierDropdown.value = false;
    };

    const resetCreateForm = () => {
      createSupplierKeyword.value = "";
      createSupplierList.value = [];
      createSupplier.value = null;
      createStoreId.value = "";
      createWareList.value = [];
      createDetails.value = [];
      createMaterialList.value = [];
      createMaterialCurrent.value = 1;
      createMaterialTotal.value = 0;
    };

    const normalizeWareList = (res) => {
      const d = res?.data;
      if (Array.isArray(d)) return d;
      if (d && Array.isArray(d.data)) return d.data;
      if (d && Array.isArray(d.records)) return d.records;
      if (d && d.data && Array.isArray(d.data.records)) return d.data.records;
      if (Array.isArray(res?.records)) return res.records;
      if (Array.isArray(res?.list)) return res.list;
      return [];
    };

    const handleCreateSupplierSearch = () => {
      createSupplierDropdown.value = true;
      if (createSupplierTimer.value)
        window.clearTimeout(createSupplierTimer.value);
      createSupplierTimer.value = window.setTimeout(async () => {
        await fetchCreateSuppliers();
      }, 250);
    };

    const handleSupplierSearch = (keyword) => {
      supplierKeyword.value = keyword;
      if (supplierTimer.value) window.clearTimeout(supplierTimer.value);
      supplierTimer.value = window.setTimeout(async () => {
        await fetchSuppliers();
      }, 800);
    };

    const handleSupplierChange = async (val) => {
      if (val) {
        const supplier = supplierList.value.find((s) => s.id === val);
        selectedSupplier.value = supplier;
        supplierKeyword.value = supplier?.supplierName || "";
      } else {
        selectedSupplier.value = null;
        supplierKeyword.value = "";
        if (route.query?.supplierId || route.query?.supplierName) {
          const q = { ...route.query };
          delete q.supplierId;
          delete q.supplierName;
          router.replace({ query: q });
        }
      }
      await fetchPage({ resetPage: true });
    };

    const normalizeSupplierRecords = (res) => {
      const d = res?.data;
      if (d && Array.isArray(d.records)) return d.records;
      if (d && d.data && Array.isArray(d.data.records)) return d.data.records;
      if (Array.isArray(d)) return d;
      if (Array.isArray(res?.records)) return res.records;
      if (Array.isArray(res?.list)) return res.list;
      return [];
    };

    const fetchSuppliers = async () => {
      if (supplierLoading.value) return;
      supplierLoading.value = true;
      try {
        const res = await getSupplierPageGtZero({
          supplierName: supplierKeyword.value.trim(),
          current: 1,
          size: 20,
        });
        supplierList.value = normalizeSupplierRecords(res);
      } catch (e) {
        supplierList.value = [];
        toast.error(e?.message || "供应商加载失败");
      } finally {
        supplierLoading.value = false;
      }
    };

    const selectSupplier = async (s) => {
      selectedSupplier.value = s;
      selectedSupplierId.value = s?.id || "";
      supplierDropdown.value = false;
      supplierKeyword.value = s?.supplierName || "";
      await fetchPage({ resetPage: true });
    };

    const clearSelectedSupplier = async () => {
      selectedSupplier.value = null;
      selectedSupplierId.value = "";
      supplierKeyword.value = "";
      supplierList.value = [];
      supplierDropdown.value = false;
      if (route.query?.supplierId || route.query?.supplierName) {
        const q = { ...route.query };
        delete q.supplierId;
        delete q.supplierName;
        router.replace({ query: q });
      }
      await fetchPage({ resetPage: true });
    };

    const closeSupplierDropdown = () => {
      supplierDropdown.value = false;
    };

    const fetchCreateSuppliers = async () => {
      if (createSupplierLoading.value) return;
      createSupplierLoading.value = true;
      try {
        const res = await getSupplierPageGtZero({
          supplierName: createSupplierKeyword.value.trim(),
          current: 1,
          size: 20,
        });
        createSupplierList.value = normalizeSupplierRecords(res);
      } catch (e) {
        createSupplierList.value = [];
        toast.error(e?.message || "供应商加载失败");
      } finally {
        createSupplierLoading.value = false;
      }
    };

    const selectCreateSupplier = async (s) => {
      createSupplier.value = s;
      createSupplierDropdown.value = false;
      createSupplierKeyword.value = s?.supplierName || "";
      createStoreId.value = "";
      createDetails.value = [];
      await fetchCreateWares();
    };

    const handleDistribute = async (item, e) => {
      try {
        e?.stopPropagation?.();
      } catch {
        // ignore
      }

      const id = item?.id;
      if (!id) return;

      try {
        await ElMessageBox.confirm("确认分配该单据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await distributeWareIn(id);
        toast.success("分配成功");
        await fetchPage({ resetPage: true });
      } catch (e) {
        if (e !== "cancel") {
          toast.error(e?.message || "分配失败");
        }
      }
    };

    const clearCreateSupplier = () => {
      resetCreateForm();
    };

    const fetchCreateWares = async () => {
      if (!createSupplier.value) return;
      if (!createBizDept.value) return;
      if (createWareLoading.value) return;
      createWareLoading.value = true;
      try {
        const res = await getWareList({ bizDept: createBizDept.value });
        createWareList.value = normalizeWareList(res);
        if (!createStoreId.value && createWareList.value.length) {
          createStoreId.value = createWareList.value[0]?.id || "";
          handleCreateWareSelect();
        }
      } catch (e) {
        createWareList.value = [];
        toast.error(e?.message || "仓库加载失败");
      } finally {
        createWareLoading.value = false;
      }
    };

    const handleCreateWareSelect = () => {
      createDetails.value = [];
      createMaterialList.value = [];
      createMaterialCurrent.value = 1;
      createMaterialTotal.value = 0;
    };

    const openCreateMaterialModal = async () => {
      if (!createSupplier.value?.id || !createStoreId.value) return;
      createMaterialVisible.value = true;
      createMaterialKeyword.value = "";
      await fetchCreateMaterials({ reset: true });
    };

    const closeCreateMaterialModal = () => {
      createMaterialVisible.value = false;
    };

    const handleCreateMaterialCancel = () => {
      createMaterialVisible.value = false;
    };

    const handleCreateMaterialConfirm = () => {
      createMaterialVisible.value = false;
    };

    const fetchCreateMaterials = async ({ reset } = {}) => {
      if (!createSupplier.value?.id || !createStoreId.value) return;
      const seq = ++createMaterialReqSeq;
      createMaterialLoading.value = true;
      try {
        if (reset) createMaterialCurrent.value = 1;
        const res = await getMaterialPage({
          current: createMaterialCurrent.value,
          size: createMaterialSize.value,
          supplierId: createSupplier.value.id,
          storeId: createStoreId.value,
          materialNo: String(createMaterialKeyword.value || "").trim(),
          isBad: 0,
          isCompose: 0,
        });
        if (seq !== createMaterialReqSeq) return;
        createMaterialList.value = res?.data?.records || [];
        createMaterialTotal.value = res?.data?.total || 0;
      } catch (e) {
        if (seq !== createMaterialReqSeq) return;
        createMaterialList.value = [];
        createMaterialTotal.value = 0;
        toast.error(e?.message || "物料加载失败");
      } finally {
        if (seq === createMaterialReqSeq) {
          createMaterialLoading.value = false;
        }
      }
    };

    const handleCreateMaterialSearch = () => {
      if (createMaterialTimer.value) {
        window.clearTimeout(createMaterialTimer.value);
      }
      createMaterialTimer.value = window.setTimeout(() => {
        fetchCreateMaterials({ reset: true });
      }, 300);
    };

    const handleCreateMaterialSearchEnter = () => {
      if (createMaterialTimer.value) {
        window.clearTimeout(createMaterialTimer.value);
      }
      fetchCreateMaterials({ reset: true });
    };

    const changeCreateMaterialPage = async (delta) => {
      const next = createMaterialCurrent.value + delta;
      if (next < 1 || next > createMaterialTotalPages.value) return;
      createMaterialCurrent.value = next;
      await fetchCreateMaterials();
    };

    const isCreateAdded = (materialId) => {
      return createDetails.value.some((d) => d.materialId === materialId);
    };

    const addCreateMaterial = (m) => {
      if (!m?.id || isCreateAdded(m.id)) return;
      createDetails.value.push({
        materialId: m.id,
        materialNo: m.materialNo || "",
        materialDesc: m.materialDesc || "",
        goodStockNum: m.goodStockNum ?? null,
        wareInNum: "",
        imageRemark: "",
        remark: "",
      });
    };

    const toggleCreateMaterial = (m) => {
      if (!m?.id) return;
      const isAdded = isCreateAdded(m.id);
      if (isAdded) {
        // 移除已添加的物料
        const idx = createDetails.value.findIndex((d) => d.materialId === m.id);
        if (idx >= 0) {
          createDetails.value.splice(idx, 1);
        }
      } else {
        // 添加物料
        addCreateMaterial(m);
      }
    };

    const truncateMaterialNo = (materialNo) => {
      if (!materialNo) return "";
      const maxLen = 18;
      if (materialNo.length <= maxLen) return materialNo;
      // 省略前面，保留后面
      return "..." + materialNo.slice(-maxLen);
    };

    const removeCreateDetail = (idx) => {
      createDetails.value.splice(idx, 1);
    };

    const normalizeCreateQty = (d) => {
      const raw = d.wareInNum;
      if (raw === "" || raw === null || raw === undefined) return;
      const n = Number(raw);
      if (!Number.isFinite(n) || n <= 0) d.wareInNum = "";
      else d.wareInNum = String(Math.floor(n));
    };

    const calcAfterCreateStock = (d) => {
      const base = parseFloatSafe(d?.goodStockNum);
      const add = parseFloatSafe(d?.wareInNum);
      const safeBase = Number.isFinite(base) ? base : 0;
      const safeAdd = Number.isFinite(add) ? add : 0;
      return formatQty(safeBase + safeAdd);
    };

    const handleSubmitCreate = async () => {
      try {
        await ElMessageBox.confirm("确认保存该单据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await submitCreate();
      } catch (e) {
        if (e !== "cancel") {
          toast.error(e?.message || "保存失败");
        }
      }
    };

    const handleCancelCreate = async () => {
      try {
        await ElMessageBox.confirm("确认取消本次操作？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        closeCreate();
      } catch (e) {
        if (e !== "cancel") {
          toast.error(e?.message || "操作失败");
        }
      }
    };

    const submitCreate = async () => {
      if (!canSubmitCreate.value || createSubmitting.value) return;
      createSubmitting.value = true;
      try {
        const payload = {
          wareInType: "0",
          storeId: createStoreId.value,
          supplierId: createSupplier.value.id,
          supplierName: createSupplier.value.supplierName,
          wareInDetailList: createDetails.value.map((d) => ({
            materialId: d.materialId,
            wareInNum: String(d.wareInNum),
            imageRemark: d.imageRemark || "",
            remark: d.remark || "",
          })),
        };
        await submitWareIn(payload);
        toast.success("保存成功");
        closeCreate();
        resetCreateForm();
        await fetchPage({ resetPage: true });
      } catch (e) {
        toast.error(e?.message || "保存失败");
      } finally {
        createSubmitting.value = false;
      }
    };

    const activeTab = ref("todo");
    const tabOptions = [
      { label: "待分配", value: "todo" },
      { label: "待收货", value: "pending" },
      { label: "已完成", value: "done" },
    ];
    const handleTabChange = (val) => {
      switchTab(val);
    };
    const current = ref(1);
    const size = ref(20);
    const removingWareInIds = ref([]);
    const multiPalletLoadingId = ref("");

    const wareInStatus = computed(() => {
      if (activeTab.value === "done") return 3;
      if (activeTab.value === "pending") return 1;
      return 0;
    });
    const canRemoveCard = computed(
      () => activeTab.value === "todo" || activeTab.value === "pending",
    );

    const list = ref([]);
    const total = ref(0);
    const selectedIds = ref([]);
    const selectedSummaryVisible = ref(false);

    const loading = ref(false);

    const statusMsg = ref("");
    const statusType = ref("info");

    const detailVisible = ref(false);
    const detailLoading = ref(false);
    const detailError = ref("");
    const receiveLoading = ref(false);

    const wareModalVisible = ref(false);
    const wareLoading = ref(false);
    const wareList = ref([]);
    const detailData = ref(null);

    const palletVisible = ref(false);
    const palletLoading = ref(false);
    const palletError = ref("");
    const supplierStockList = ref([]);
    const palletOpeningMap = ref({});

    const collectErrorVisible = ref(false);
    const collectErrorMsg = ref("");

    const failDescExpanded = ref({});

    const palletCode = ref("");
    const palletQty = ref("");
    const palletItems = ref([]);

    const palletCodeInput = ref(null);
    const palletFileInput = ref(null);
    const palletSearchOptions = ref([]);
    const palletSearchLoading = ref(false);
    const palletSearchSeq = ref(0);

    const focusPalletCodeInput = () => {
      nextTick(() => {
        const comp = palletCodeInput.value;
        if (!comp) return;
        if (typeof comp.focus === "function") {
          comp.focus();
          return;
        }
        const el = comp.$el?.querySelector?.("input");
        el?.focus?.();
      });
    };

    const getPalletCodeNativeInput = () => {
      const comp = palletCodeInput.value;
      if (!comp) return null;
      return comp.$el?.querySelector?.("input") || null;
    };

    const cameraVisible = ref(false);
    const scanError = ref("");
    const html5Qrcode = ref(null);
    const scanSuccessLocked = ref(false);
    const stopScanInProgress = ref(false);
    const scanFallbackTimer = ref(0);
    const palletScanVisible = ref(false);

    const palletComposing = ref(false);
    const stopScanPromise = ref(Promise.resolve());
    const barcodeStream = ref(null);
    const barcodeRafId = ref(0);
    const barcodeVideo = ref(null);
    const barcodeDetector = ref(null);
    const barcodeCanvas = ref(null);

    const zxingStream = ref(null);
    const zxingRafId = ref(0);
    const zxingVideo = ref(null);
    const zxingCanvas = ref(null);
    const zxingCtx = ref(null);
    const zxingReadBarcodes = ref(null);
    const zxingInFlight = ref(false);

    const recognizing = ref(false);
    const scanSuccessVisible = ref(false);
    const scanSuccessMsg = ref("");
    let scanSuccessTimer = 0;

    const showScanSuccess = (msg = "识别成功") => {
      scanSuccessMsg.value = msg;
      scanSuccessVisible.value = true;
      if (scanSuccessTimer) window.clearTimeout(scanSuccessTimer);
      scanSuccessTimer = window.setTimeout(() => {
        scanSuccessVisible.value = false;
      }, 900);
    };

    const withTimeout = (promise, ms) => {
      return Promise.race([
        promise,
        new Promise((_, reject) => {
          window.setTimeout(() => reject(new Error("timeout")), ms);
        }),
      ]);
    };

    const isIOS = () => {
      const ua = navigator.userAgent || "";
      return /iPad|iPhone|iPod/i.test(ua);
    };

    const clearScanRegion = (regionId) => {
      try {
        const el = document.getElementById(regionId);
        if (el) el.innerHTML = "";
      } catch {
        // ignore
      }

      recognizing.value = false;
    };

    const loadZXingWasmReader = async () => {
      if (zxingReadBarcodes.value) return zxingReadBarcodes.value;
      const w = window;

      if (w.ZXingWASM?.readBarcodes) {
        zxingReadBarcodes.value = w.ZXingWASM.readBarcodes;
        return zxingReadBarcodes.value;
      }

      try {
        await new Promise((resolve, reject) => {
          const existing = document.querySelector(
            'script[data-zxing-wasm="1"]',
          );
          if (existing) {
            const check = () => {
              if (w.ZXingWASM?.readBarcodes) resolve();
              else window.setTimeout(check, 50);
            };
            check();
            return;
          }

          const s = document.createElement("script");
          s.async = true;
          s.dataset.zxingWasm = "1";
          s.src =
            "https://cdn.jsdelivr.net/npm/zxing-wasm@1.2.7/dist/iife/reader/index.js";
          s.onload = () => resolve();
          s.onerror = (evt) => {
            const msg = evt?.message || evt?.type || "script_load_error";
            reject(new Error(`zxing_wasm_load_failed:${msg}`));
          };
          document.head.appendChild(s);
        });

        if (w.ZXingWASM?.readBarcodes) {
          zxingReadBarcodes.value = w.ZXingWASM.readBarcodes;
        }
        return zxingReadBarcodes.value;
      } catch (error) {
        console.warn("ZXing WASM加载失败，将使用兼容模式:", error.message);
        return null;
      }
    };

    const getCameraStream = async () => {
      const candidates = [
        {
          audio: false,
          video: {
            facingMode: { ideal: "environment" },
            width: { ideal: 640 },
            height: { ideal: 480 },
            frameRate: { ideal: 30, max: 30 },
          },
        },
        {
          audio: false,
          video: {
            facingMode: { ideal: "environment" },
          },
        },
      ];

      let lastErr = null;
      for (const c of candidates) {
        try {
          return await navigator.mediaDevices.getUserMedia(c);
        } catch (e) {
          lastErr = e;
        }
      }
      throw lastErr || new Error("getUserMedia failed");
    };

    const waitVideoReady = async (video, timeoutMs = 1500) => {
      if (!video) return;
      if (video.readyState >= 2 && (video.videoWidth || 0) > 0) return;

      await new Promise((resolve, reject) => {
        const t = window.setTimeout(() => {
          cleanup();
          reject(new Error("video_timeout"));
        }, timeoutMs);

        const onReady = () => {
          if (video.readyState >= 2 && (video.videoWidth || 0) > 0) {
            cleanup();
            resolve();
          }
        };

        const cleanup = () => {
          window.clearTimeout(t);
          video.removeEventListener("loadeddata", onReady);
          video.removeEventListener("loadedmetadata", onReady);
          video.removeEventListener("canplay", onReady);
          video.removeEventListener("playing", onReady);
        };

        video.addEventListener("loadeddata", onReady);
        video.addEventListener("loadedmetadata", onReady);
        video.addEventListener("canplay", onReady);
        video.addEventListener("playing", onReady);

        // 兼容部分机型事件不触发
        const poll = () => {
          if (video.readyState >= 2 && (video.videoWidth || 0) > 0) {
            cleanup();
            resolve();
            return;
          }
          window.setTimeout(poll, 50);
        };
        poll();
      });
    };

    const stopZXingWasmDetector = () => {
      try {
        if (zxingRafId.value) {
          window.cancelAnimationFrame(zxingRafId.value);
        }
      } catch {
        // ignore
      }
      zxingRafId.value = 0;

      try {
        const stream = zxingStream.value;
        if (stream) {
          stream.getTracks().forEach((t) => t.stop());
        }
      } catch {
        // ignore
      }
      zxingStream.value = null;

      try {
        const v = zxingVideo.value;
        if (v) {
          v.pause?.();
          v.srcObject = null;
        }
      } catch {
        // ignore
      }

      zxingVideo.value = null;
      zxingCanvas.value = null;
      zxingCtx.value = null;
      zxingInFlight.value = false;
    };

    const startZXingWasmDetector = async (regionId) => {
      try {
        const readBarcodes = await loadZXingWasmReader();
        if (!readBarcodes) return false;

        stopZXingWasmDetector();
        clearScanRegion(regionId);

        const container = document.getElementById(regionId);
        if (!container) return false;

        const video = document.createElement("video");
        video.setAttribute("playsinline", "true");
        video.setAttribute("webkit-playsinline", "true");
        video.muted = true;
        video.autoplay = true;
        video.style.width = "100%";
        video.style.height = "320px";
        video.style.objectFit = "cover";
        container.appendChild(video);

        const stream = await getCameraStream();

        zxingStream.value = stream;
        zxingVideo.value = video;
        video.srcObject = stream;
        await video.play();
        await waitVideoReady(video);

        const canvas = document.createElement("canvas");
        canvas.width = 320;
        canvas.height = 320;
        zxingCanvas.value = canvas;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) {
          stopZXingWasmDetector();
          clearScanRegion(regionId);
          return false;
        }
        zxingCtx.value = ctx;

        const options = {
          formats: ["QRCode", "Code128", "ITF"],
          maxNumberOfSymbols: 1,
          tryHarder: false,
        };

        let lastTs = 0;
        const tick = async (ts) => {
          if (!cameraVisible.value) return;
          if (scanSuccessLocked.value) return;
          if (zxingInFlight.value) {
            zxingRafId.value = window.requestAnimationFrame(tick);
            return;
          }
          if (ts - lastTs < 70) {
            zxingRafId.value = window.requestAnimationFrame(tick);
            return;
          }
          lastTs = ts;

          try {
            const vw = video.videoWidth || 0;
            const vh = video.videoHeight || 0;
            if (vw > 0 && vh > 0) {
              const s = Math.min(vw, vh);
              const sx = Math.floor((vw - s) / 2);
              const sy = Math.floor((vh - s) / 2);
              ctx.drawImage(video, sx, sy, s, s, 0, 0, 320, 320);
            } else {
              ctx.drawImage(video, 0, 0, 320, 320);
            }

            const imageData = ctx.getImageData(0, 0, 320, 320);
            zxingInFlight.value = true;
            const results = await readBarcodes(imageData, options);
            const text = results?.[0]?.text;
            if (text) {
              scanSuccessLocked.value = true;
              recognizing.value = true;
              try {
                applyScannedPalletCode(text);
                showScanSuccess("识别成功");
                recognizing.value = false;
                window.setTimeout(() => {
                  stopMobileScan();
                }, 0);
              } catch (e) {
                scanError.value = e?.message || "处理托盘码失败";
                recognizing.value = false;
                scanSuccessLocked.value = false;
              }
              return;
            }
          } catch {
            // ignore
          } finally {
            zxingInFlight.value = false;
          }

          zxingRafId.value = window.requestAnimationFrame(tick);
        };

        zxingRafId.value = window.requestAnimationFrame(tick);
        return true;
      } catch {
        stopZXingWasmDetector();
        clearScanRegion(regionId);
        return false;
      }
    };

    const stopNativeBarcodeDetector = () => {
      try {
        if (barcodeRafId.value) {
          window.cancelAnimationFrame(barcodeRafId.value);
        }
      } catch {
        // ignore
      }
      barcodeRafId.value = 0;

      try {
        const stream = barcodeStream.value;
        if (stream) {
          stream.getTracks().forEach((t) => t.stop());
        }
      } catch {
        // ignore
      }
      barcodeStream.value = null;

      try {
        const v = barcodeVideo.value;
        if (v) {
          v.pause?.();
          v.srcObject = null;
        }
      } catch {
        // ignore
      }
      barcodeVideo.value = null;
      barcodeDetector.value = null;
      barcodeCanvas.value = null;
    };

    const startNativeBarcodeDetector = async (regionId) => {
      if (!window.BarcodeDetector) return false;
      let detector;
      try {
        detector = new window.BarcodeDetector({
          formats: ["qr_code", "code_128", "itf"],
        });
      } catch {
        return false;
      }

      try {
        stopNativeBarcodeDetector();
        clearScanRegion(regionId);

        const container = document.getElementById(regionId);
        if (!container) return false;

        const video = document.createElement("video");
        video.setAttribute("playsinline", "true");
        video.setAttribute("webkit-playsinline", "true");
        video.muted = true;
        video.autoplay = true;
        video.style.width = "100%";
        video.style.height = "320px";
        video.style.objectFit = "cover";
        container.appendChild(video);

        const stream = await getCameraStream();

        barcodeDetector.value = detector;
        barcodeStream.value = stream;
        barcodeVideo.value = video;
        video.srcObject = stream;
        await video.play();
        await waitVideoReady(video);

        const canvas = document.createElement("canvas");
        canvas.width = 320;
        canvas.height = 320;
        barcodeCanvas.value = canvas;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) {
          stopNativeBarcodeDetector();
          clearScanRegion(regionId);
          return false;
        }

        let lastTs = 0;
        const tick = async (ts) => {
          if (!cameraVisible.value) return;
          if (scanSuccessLocked.value) return;
          if (ts - lastTs < 45) {
            barcodeRafId.value = window.requestAnimationFrame(tick);
            return;
          }
          lastTs = ts;

          try {
            const vw = video.videoWidth || 0;
            const vh = video.videoHeight || 0;
            if (vw > 0 && vh > 0) {
              const s = Math.min(vw, vh);
              const sx = Math.floor((vw - s) / 2);
              const sy = Math.floor((vh - s) / 2);
              ctx.drawImage(video, sx, sy, s, s, 0, 0, 320, 320);
            } else {
              ctx.drawImage(video, 0, 0, 320, 320);
            }

            const codes = await detector.detect(canvas);
            const raw = codes?.[0]?.rawValue;
            if (raw) {
              scanSuccessLocked.value = true;
              recognizing.value = true;
              try {
                applyScannedPalletCode(raw);
                showScanSuccess("识别成功");
                recognizing.value = false;
                window.setTimeout(() => {
                  stopMobileScan();
                }, 0);
              } catch (e) {
                scanError.value = e?.message || "处理托盘码失败";
                recognizing.value = false;
                scanSuccessLocked.value = false;
              }
              return;
            }
          } catch {
            // ignore
          }

          barcodeRafId.value = window.requestAnimationFrame(tick);
        };

        barcodeRafId.value = window.requestAnimationFrame(tick);
        return true;
      } catch {
        stopNativeBarcodeDetector();
        clearScanRegion(regionId);
        return false;
      }
    };

    const totalPages = computed(() => {
      const pages = Math.ceil((Number(total.value) || 0) / (size.value || 20));
      return Math.max(pages, 1);
    });

    const handleBack = () => router.push("/home");
    const goHome = () => router.push("/home");

    const formatTime = (val) => {
      if (!val) return "-";
      const raw = typeof val === "string" ? val : String(val);
      const safe =
        raw.includes(" ") && !raw.includes("T") ? raw.replace(" ", "T") : raw;
      const d = new Date(safe);
      if (Number.isNaN(d.getTime())) return String(val);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const hh = String(d.getHours()).padStart(2, "0");
      const mi = String(d.getMinutes()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
    };

    const formatDate = (val) => {
      if (!val) return "";
      const raw = typeof val === "string" ? val : String(val);
      const safe =
        raw.includes(" ") && !raw.includes("T") ? raw.replace(" ", "T") : raw;
      const d = new Date(safe);
      if (Number.isNaN(d.getTime())) return "";
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formatQty = (val) => {
      if (val === null || val === undefined || val === "") return "-";
      const n = Number(val);
      if (Number.isNaN(n)) return String(val);
      return n.toFixed(3);
    };

    const getMaterialNoDisplay = (item) => {
      if (item.materialNo) return item.materialNo;
      const details = item.wareInDetailList || [];
      const materialNos = [
        ...new Set(details.map((d) => d.materialNo).filter(Boolean)),
      ];
      return materialNos.length > 0 ? materialNos.join(", ") : "-";
    };

    const hasMultiVersion = (item) => {
      return Number(item?.materialVersionStatus) === 1;
    };

    const isDetailMultiVersion = computed(
      () => Number(detailData.value?.materialVersionStatus) === 1,
    );

    // ===== 多版本子物料选择 =====
    const versionSelectVisible = ref(false);
    const versionListLoading = ref(false);
    const versionSubmitting = ref(false);
    const versionLoadingId = ref("");
    const versionList = ref([]);
    const versionParentMaterial = ref(null);
    const versionWareInDetail = ref(null);
    const versionWareIn = ref(null);
    const selectedVersion = ref(null);
    const selectedVersionId = computed(() =>
      String(selectedVersion.value?.id || ""),
    );

    const closeVersionSelect = () => {
      versionSelectVisible.value = false;
      versionListLoading.value = false;
      versionSubmitting.value = false;
      versionLoadingId.value = "";
      versionList.value = [];
      versionParentMaterial.value = null;
      versionWareInDetail.value = null;
      versionWareIn.value = null;
      selectedVersion.value = null;
    };

    const openVersionSelect = async (detail, wareIn = null) => {
      const materialId = detail?.materialId;
      if (!materialId) {
        ElMessage.error("缺少物料ID");
        return;
      }
      versionWareInDetail.value = detail;
      versionWareIn.value = wareIn || detailData.value || null;
      versionParentMaterial.value = {
        materialId: String(materialId),
        materialNo: detail?.materialNo || "",
        materialDesc: detail?.materialDesc || "",
      };
      selectedVersion.value = null;
      versionList.value = [];
      versionSelectVisible.value = true;
      versionListLoading.value = true;
      versionLoadingId.value = String(materialId);
      try {
        const res = await getMaterialVersionList(materialId);
        const data = res?.data;
        versionList.value = Array.isArray(data)
          ? data
          : Array.isArray(data?.records)
          ? data.records
          : [];
      } catch (e) {
        versionList.value = [];
        ElMessage.error(e?.message || "查询子版本失败");
      } finally {
        versionListLoading.value = false;
        versionLoadingId.value = "";
      }
    };

    const openVersionSelectFromList = (item) => {
      if (!hasMultiVersion(item)) {
        ElMessage.warning("当前单据不是多版本物料");
        return;
      }
      const details = item?.wareInDetailList || [];
      const target =
        details.find((d) => d?.materialId) || details[0] || null;
      if (!target?.materialId) {
        ElMessage.warning("未找到可修改的物料");
        return;
      }
      openVersionSelect(target, item);
    };

    const selectVersion = (v) => {
      if (!v?.id) return;
      selectedVersion.value = v;
    };

    const submitVersionSelect = async () => {
      if (!selectedVersion.value?.id) {
        ElMessage.warning("请选择一个子版本");
        return;
      }

      const wareInId = String(
        versionWareIn.value?.id ||
          versionWareIn.value?.wareInId ||
          detailData.value?.id ||
          detailData.value?.wareInId ||
          "",
      );
      const oldMaterialId = String(
        versionParentMaterial.value?.materialId ||
          versionWareInDetail.value?.materialId ||
          "",
      );
      const newMaterialId = String(selectedVersion.value?.id || "");

      if (!wareInId) {
        ElMessage.error("缺少入库单ID");
        return;
      }
      if (!oldMaterialId) {
        ElMessage.error("缺少原物料ID");
        return;
      }
      if (!newMaterialId) {
        ElMessage.error("缺少新物料ID");
        return;
      }

      const newNo = selectedVersion.value?.materialNo || "-";
      try {
        await ElMessageBox.confirm(
          `确认将物料切换为子版本「${newNo}」吗？`,
          "确认选择",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            appendTo: document.body,
            customClass: "version-confirm-box",
            zIndex: 5000,
          },
        );
      } catch {
        return;
      }

      if (versionSubmitting.value) return;
      versionSubmitting.value = true;
      try {
        await updateWareInVersionFlag({
          id: wareInId,
          oldMaterialId,
          newMaterialId,
        });
        toast.success("子版本修改成功");
        closeVersionSelect();

        if (detailVisible.value && wareInId) {
          try {
            const res = await getWareInReceiveDetail(wareInId);
            detailData.value = res?.data || detailData.value;
          } catch {
            // ignore
          }
        }
        await fetchPage({ resetPage: true });
      } catch (e) {
        toast.error(e?.message || "子版本修改失败");
      } finally {
        versionSubmitting.value = false;
      }
    };

    const getTotalWareInNum = (item) => {
      if (item.wareInNum) return item.wareInNum;
      const details = item.wareInDetailList || [];
      return details.reduce((sum, d) => sum + parseFloatSafe(d.wareInNum), 0);
    };

    const parseFloatSafe = (val) => {
      const n = Number(val);
      return Number.isNaN(n) ? 0 : n;
    };

    const normalizePalletCode = (raw) => {
      return (
        String(raw ?? "")
          .replace(/[\u200B-\u200D\uFEFF]/g, "") // 移除零宽字符
          .replace(/[\r\n\t]/g, "") // 移除换行、回车、制表符
          // eslint-disable-next-line no-control-regex
          .replace(/[\x00-\x1F\x7F]/g, "") // 移除 ASCII 控制字符和 DEL 字符
          .trim()
      );
    };

    const decodeQrByJsQR = async (file) => {
      try {
        let bitmap = null;
        if (typeof window.createImageBitmap === "function") {
          try {
            bitmap = await window.createImageBitmap(file, {
              imageOrientation: "from-image",
            });
          } catch {
            bitmap = await window.createImageBitmap(file);
          }
        }

        let width = 0;
        let height = 0;

        if (bitmap) {
          width = bitmap.width;
          height = bitmap.height;
        } else {
          const url = URL.createObjectURL(file);
          const img = await new Promise((resolve, reject) => {
            const im = new Image();
            im.onload = () => resolve(im);
            im.onerror = (evt) => {
              const msg = evt?.message || evt?.type || "image_load_error";
              reject(new Error(`image_load_failed:${msg}`));
            };
            im.src = url;
          });
          URL.revokeObjectURL(url);
          width = img.naturalWidth || img.width;
          height = img.naturalHeight || img.height;
          bitmap = img;
        }

        if (!width || !height) return "";

        const tryDecode = (imgData) => {
          try {
            const res = jsQR(imgData.data, imgData.width, imgData.height, {
              inversionAttempts: "attemptBoth",
            });
            return res?.data || "";
          } catch {
            return "";
          }
        };

        const rotateCanvas = (srcCanvas, deg) => {
          const rad = (deg * Math.PI) / 180;
          const sw = srcCanvas.width;
          const sh = srcCanvas.height;
          const dst = document.createElement("canvas");
          if (deg === 90 || deg === 270) {
            dst.width = sh;
            dst.height = sw;
          } else {
            dst.width = sw;
            dst.height = sh;
          }
          const dctx = dst.getContext("2d", { willReadFrequently: true });
          if (!dctx) return null;
          dctx.translate(dst.width / 2, dst.height / 2);
          dctx.rotate(rad);
          dctx.drawImage(srcCanvas, -sw / 2, -sh / 2);
          return dst;
        };

        const normalize = (text) => {
          return String(text || "")
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/[\r\n\t]/g, "")
            .trim();
        };

        const contrast = (src, factor) => {
          const out = new ImageData(src.width, src.height);
          const s = src.data;
          const d = out.data;
          for (let i = 0; i < s.length; i += 4) {
            const r = s[i];
            const g = s[i + 1];
            const b = s[i + 2];
            // luma
            const y = 0.299 * r + 0.587 * g + 0.114 * b;
            let v = (y - 128) * factor + 128;
            v = Math.max(0, Math.min(255, v));
            d[i] = v;
            d[i + 1] = v;
            d[i + 2] = v;
            d[i + 3] = 255;
          }
          return out;
        };

        const binarize = (src, threshold, invert) => {
          const out = new ImageData(src.width, src.height);
          const s = src.data;
          const d = out.data;
          for (let i = 0; i < s.length; i += 4) {
            const r = s[i];
            const g = s[i + 1];
            const b = s[i + 2];
            // luma
            let v = 0.299 * r + 0.587 * g + 0.114 * b;
            v = v >= threshold ? 255 : 0;
            if (invert) v = 255 - v;
            d[i] = v;
            d[i + 1] = v;
            d[i + 2] = v;
            d[i + 3] = 255;
          }
          return out;
        };

        // 多尺度 + 多角度尝试：拍屏幕/倾斜时更稳
        const maxSide = 1200;
        const baseScale = Math.min(1, maxSide / Math.max(width, height));
        const scaleCandidates = [1, 0.8, 0.65].map((k) => k * baseScale);
        const angles = [0, 90, 180, 270];

        for (const scale of scaleCandidates) {
          const w = Math.max(1, Math.floor(width * scale));
          const h = Math.max(1, Math.floor(height * scale));
          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d", { willReadFrequently: true });
          if (!ctx) continue;
          ctx.drawImage(bitmap, 0, 0, w, h);

          for (const ang of angles) {
            const rotated = ang === 0 ? canvas : rotateCanvas(canvas, ang);
            if (!rotated) continue;

            const rctx = rotated.getContext("2d", { willReadFrequently: true });
            if (!rctx) continue;

            const rw = rotated.width;
            const rh = rotated.height;
            const full = rctx.getImageData(0, 0, rw, rh);

            // 1) 原图直接尝试
            let decoded = normalize(tryDecode(full));
            if (decoded) return decoded;

            // 1.1) 轻度对比度增强尝试
            for (const f of [1.25, 1.45]) {
              decoded = normalize(tryDecode(contrast(full, f)));
              if (decoded) return decoded;
            }

            // 2) 居中裁剪（屏幕拍照/背景复杂时更稳）
            const cropRates = [0.82, 0.68];
            for (const rate of cropRates) {
              const cw = Math.max(1, Math.floor(rw * rate));
              const ch = Math.max(1, Math.floor(rh * rate));
              const sx = Math.max(0, Math.floor((rw - cw) / 2));
              const sy = Math.max(0, Math.floor((rh - ch) / 2));
              const crop = rctx.getImageData(sx, sy, cw, ch);
              decoded = normalize(tryDecode(crop));
              if (decoded) return decoded;
            }

            // 3) 二值化多阈值尝试（拍屏幕摩尔纹/灰度不均时更稳）
            const thresholds = [90, 110, 128, 145, 165];
            for (const t of thresholds) {
              decoded = normalize(tryDecode(binarize(full, t, false)));
              if (decoded) return decoded;

              decoded = normalize(tryDecode(binarize(full, t, true)));
              if (decoded) return decoded;
            }
          }
        }

        return "";
      } catch {
        return "";
      }
    };

    const getWareInTypeText = (val) => {
      if (val === 0 || val === "0") return "收货入库";
      if (val === 1 || val === "1") return "退货入库";
      if (val === 4 || val === "4") return "计划取消";
      return "收货入库";
    };

    const getWareInTypeClass = (val) => {
      if (val === 0 || val === "0") return "type-0";
      if (val === 1 || val === "1") return "type-1";
      if (val === 4 || val === "4") return "type-4";
      return "type-0";
    };

    const isReturnBad = (row) => {
      const type = row?.wareInType ?? row?.inType;
      const isReturn = type === 1 || type === "1";
      if (!isReturn) return false;

      const bad =
        row?.isBad ?? row?.badFlag ?? row?.qualityType ?? row?.qualityFlag;
      return bad === 1 || bad === "1" || bad === true;
    };

    const isReturnGood = (row) => {
      const type = row?.wareInType ?? row?.inType;
      const isReturn = type === 1 || type === "1";
      if (!isReturn) return false;

      const bad =
        row?.isBad ?? row?.badFlag ?? row?.qualityType ?? row?.qualityFlag;
      return (
        bad === 0 ||
        bad === "0" ||
        bad === false ||
        bad === undefined ||
        bad === null
      );
    };

    const handleToggleBad = async (item) => {
      const id = item.id || item.wareInId;
      if (!id) return;

      const isBad = isReturnBad(item);
      const message = isBad
        ? `确认将此单据改为良品？`
        : `确认将此单据改为不良品？`;

      try {
        await ElMessageBox.confirm(message, "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });

        const res = await updateIsBad(id);
        if (res?.success || res?.code === 200) {
          toast.success("切换成功");
          fetchPage({ resetPage: true });
        } else {
          toast.error(res?.message || "切换失败");
        }
      } catch (e) {
        if (e !== "cancel") {
          console.error("切换良品/不良品失败:", e);
          toast.error("切换失败");
        }
      }
    };

    const formatNum = (val) => {
      if (val === null || val === undefined || val === "") return "-";
      const n = Number(val);
      if (Number.isNaN(n)) return String(val);
      return n.toFixed(2);
    };

    const fetchPage = async ({ resetPage = false } = {}) => {
      if (resetPage) {
        current.value = 1;
        selectedIds.value = [];
      }

      loading.value = true;
      statusMsg.value = "";

      try {
        const params = {
          current: current.value,
          size: size.value,
          wareInStatus: wareInStatus.value,
          sortField: sortField.value || "materialNo",
          supplierId: selectedSupplier.value?.id,
          supplierName:
            !selectedSupplier.value && supplierKeyword.value.trim()
              ? supplierKeyword.value.trim()
              : undefined,
          ...getSearchNoParams(),
        };

        if (wareInTypeFilter.value !== "") {
          params.wareInType = wareInTypeFilter.value;
        }

        if (timeFilter.value) {
          const now = new Date();
          const endTime = now.toISOString().split("T")[0];
          let days = 0;
          if (timeFilter.value === "lastHalfMonth") {
            days = 15;
          } else if (timeFilter.value === "lastMonth") {
            days = 30;
          }
          const startTime = new Date(now.getTime() - days * 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0];
          params.startTime = startTime;
          params.endTime = endTime;
        }

        const res = await getWareInReceivePage(params);

        const records = res?.data?.records || [];
        list.value = records;
        total.value = Number(res?.data?.total) || 0;

        // 当前页超出总页数时回退到最后一页
        const pages = Math.max(
          1,
          Math.ceil((total.value || 0) / (size.value || 20)),
        );
        if (current.value > pages) {
          current.value = pages;
          if (pages >= 1) {
            await fetchPage({ resetPage: false });
            return;
          }
        }

        if (records.length === 0) {
          statusMsg.value = "";
        }
      } catch (e) {
        list.value = [];
        total.value = 0;
        statusMsg.value = e?.message || "加载失败";
        statusType.value = "error";
      } finally {
        loading.value = false;
      }
    };

    const switchTab = async (tab) => {
      activeTab.value = tab;
      selectedIds.value = [];
      // 已完成默认按入库时间；其他页签默认按编码
      sortField.value = tab === "done" ? "wareInTime" : "materialNo";
      await fetchPage({ resetPage: true });
    };

    const goPrevPage = async () => {
      if (current.value <= 1 || loading.value) return;
      current.value -= 1;
      selectedIds.value = [];
      await fetchPage({ resetPage: false });
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const goNextPage = async () => {
      if (current.value >= totalPages.value || loading.value) return;
      current.value += 1;
      selectedIds.value = [];
      await fetchPage({ resetPage: false });
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const getWareInId = (item) => item?.id || item?.wareInId || "";

    const isRemoving = (item) => {
      const id = String(getWareInId(item) || "");
      if (!id) return false;
      return removingWareInIds.value.includes(id);
    };

    const handleRemoveWareIn = async (item, e) => {
      if (e?.preventDefault) e.preventDefault();
      if (e?.stopPropagation) e.stopPropagation();
      if (!canRemoveCard.value) return;

      const wareInId = String(getWareInId(item) || "");
      if (!wareInId) {
        toast.error("缺少入库单ID");
        return;
      }
      if (removingWareInIds.value.includes(wareInId)) return;

      try {
        await ElMessageBox.confirm("是否确认删除该单据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        removingWareInIds.value = removingWareInIds.value.concat(wareInId);
        try {
          const res = await removeWareIn(wareInId);
          if (res?.success === false) throw new Error(res?.msg || "删除失败");
          toast.success("删除成功");
          await fetchPage({ resetPage: true });
        } catch (err) {
          toast.error(err?.message || "删除失败");
        } finally {
          removingWareInIds.value = removingWareInIds.value.filter(
            (x) => x !== wareInId,
          );
        }
      } catch (e) {
        if (e !== "cancel") {
          toast.error(e?.message || "删除失败");
        }
      }
    };

    const openReceiveDetail = async (item) => {
      const id = item?.id;
      if (!id) return;
      receiveLoading.value = true;
      detailError.value = "";
      detailData.value = null;
      try {
        const res = await getWareInReceiveDetail(id);
        detailData.value = res?.data || null;
        detailVisible.value = true;
        detailLoading.value = false;
      } catch (e) {
        detailError.value = e?.message || "加载失败";
        detailVisible.value = true;
      } finally {
        receiveLoading.value = false;
      }
    };

    // 列表数据已含物料数/多版本标记，这里只做本地校验；详情由单物料页再请求一次
    const openSingleReceive = (item) => {
      const id = item?.id;
      if (!id) return;

      if (hasMultiVersion(item)) {
        ElMessage.warning("多版本物料暂时不能入库，找账务员修改对应子版本物料");
        return;
      }

      const materialCount =
        item?.wareMaterialNum || item?.wareInDetailList?.length || 0;
      if (materialCount > 1) {
        ElMessage.error(
          "入库单有多个物料，无法进行单物料收货，只能通过多物料收货",
        );
        return;
      }

      const supplierId = selectedSupplier.value?.id || "";
      const supplierName =
        selectedSupplier.value?.supplierName || supplierKeyword.value || "";
      let url = `/warein-receive/single?wareInId=${id}`;
      if (supplierId) url += `&supplierId=${supplierId}`;
      if (supplierName)
        url += `&supplierName=${encodeURIComponent(supplierName)}`;
      const nk = noKeyword.value?.trim();
      if (nk) url += `&noKeyword=${encodeURIComponent(nk)}`;
      if (noSearchType.value) url += `&noSearchType=${noSearchType.value}`;
      router.push(url);
    };

    const openMultiMaterialMultiPallet = (item) => {
      const id = item?.id;
      if (!id) return;
      multiPalletLoadingId.value = id;
      const supplierId = selectedSupplier.value?.id || "";
      const supplierName =
        selectedSupplier.value?.supplierName || supplierKeyword.value || "";
      let url = `/warein-receive/multi-pallet?wareInId=${id}`;
      if (supplierId) url += `&supplierId=${supplierId}`;
      if (supplierName)
        url += `&supplierName=${encodeURIComponent(supplierName)}`;
      const nk = noKeyword.value?.trim();
      if (nk) url += `&noKeyword=${encodeURIComponent(nk)}`;
      if (noSearchType.value) url += `&noSearchType=${noSearchType.value}`;
      setTimeout(() => {
        router.push(url);
      }, 500);
    };

    const openRedash = (item) => {
      const id = item?.id || item?.wareInId;
      if (!id) return;
      router.push(`/warein-receive/redash?wareInId=${id}`);
    };

    const hasMultipleMaterials = (item) => {
      const materialCount =
        item?.wareMaterialNum || item?.wareInDetailList?.length || 0;
      return materialCount > 1;
    };

    const canSelectReturnItem = (item) => {
      if (!item) return false;
      const isReturn = item.wareInType === 1 || item.wareInType === "1";
      if (!isReturn) return false;
      if (hasMultipleMaterials(item)) return false;
      if (hasMultiVersion(item)) return false;
      return true;
    };

    const toggleSelect = (item) => {
      const id = getWareInId(item);
      if (!id) return;

      const idx = selectedIds.value.indexOf(id);
      if (idx >= 0) {
        selectedIds.value.splice(idx, 1);
      } else {
        if (!canSelectReturnItem(item)) {
          if (hasMultiVersion(item)) {
            toast.warning("多版本退货入库单据不支持批量选择");
          } else if (hasMultipleMaterials(item)) {
            toast.warning("多物料单据不支持批量选择");
          }
          return;
        }
        if (selectedIds.value.length >= 10) {
          toast.error("最多只能选择10条单据");
          return;
        }

        if (selectedIds.value.length > 0) {
          const firstSelected = list.value.find((i) =>
            selectedIds.value.includes(getWareInId(i)),
          );
          if (
            firstSelected &&
            firstSelected.supplierName !== item.supplierName
          ) {
            toast.error("只能选择同一供应商的单据");
            return;
          }
        }

        selectedIds.value.push(id);
      }
    };

    const isAllSelected = computed(() => {
      const returnItems = list.value.filter((item) => canSelectReturnItem(item));
      const selectCount = Math.min(returnItems.length, 10);
      if (selectCount === 0) return false;
      if (selectedIds.value.length !== selectCount) return false;
      for (let i = 0; i < selectCount; i++) {
        const id = getWareInId(returnItems[i]);
        if (!selectedIds.value.includes(id)) {
          return false;
        }
      }
      return true;
    });

    const toggleSelectAll = () => {
      if (isAllSelected.value) {
        const returnItems = list.value.filter((item) => canSelectReturnItem(item));
        if (returnItems.length > 0) {
          const firstSupplier = returnItems[0].supplierName;
          const sameSupplierItems = returnItems.filter(
            (item) => item.supplierName === firstSupplier,
          );
          const selectCount = Math.min(sameSupplierItems.length, 10);
          for (let i = 0; i < selectCount; i++) {
            const id = getWareInId(sameSupplierItems[i]);
            const idx = selectedIds.value.indexOf(id);
            if (idx >= 0) {
              selectedIds.value.splice(idx, 1);
            }
          }
        }
        toast.success("已取消全选");
      } else {
        selectedIds.value = [];
        const returnItems = list.value.filter((item) => canSelectReturnItem(item));
        if (returnItems.length === 0) {
          toast.warning("没有可选择的退货入库单据");
          return;
        }
        const firstSupplier = returnItems[0].supplierName;
        const sameSupplierItems = returnItems.filter(
          (item) => item.supplierName === firstSupplier,
        );
        const selectCount = Math.min(sameSupplierItems.length, 10);
        for (let i = 0; i < selectCount; i++) {
          const id = getWareInId(sameSupplierItems[i]);
          if (id) {
            selectedIds.value.push(id);
          }
        }
        if (selectedIds.value.length === 0) {
          toast.warning("没有可选择的退货入库单据");
        } else {
          toast.success(`已选择 ${selectedIds.value.length} 条退货入库单据`);
        }
      }
    };

    const selectedMaterialSummary = computed(() => {
      const materialMap = {};
      const selectedItems = list.value.filter((item) =>
        selectedIds.value.includes(getWareInId(item)),
      );
      selectedItems.forEach((item) => {
        const details = item.wareInDetailList || [];
        details.forEach((detail) => {
          const materialNo = detail.materialNo || "";
          const qty = parseFloat(detail.wareInNum) || 0;
          if (!materialMap[materialNo]) {
            materialMap[materialNo] = {
              materialNo,
              totalQty: 0,
            };
          }
          materialMap[materialNo].totalQty += qty;
        });
      });
      return Object.values(materialMap);
    });

    const totalMaterialQty = computed(() => {
      return selectedMaterialSummary.value.reduce(
        (sum, item) => sum + item.totalQty,
        0,
      );
    });

    const selectedSupplierName = computed(() => {
      if (selectedIds.value.length === 0) return null;
      const firstSelected = list.value.find((item) =>
        selectedIds.value.includes(getWareInId(item)),
      );
      return firstSelected?.supplierName || null;
    });

    const openSelectedSummary = () => {
      selectedSummaryVisible.value = true;
    };

    const closeSelectedSummary = () => {
      selectedSummaryVisible.value = false;
    };

    const handleBatchReceive = () => {
      if (selectedIds.value.length === 0) return;
      const selectedItems = list.value.filter((item) =>
        selectedIds.value.includes(getWareInId(item)),
      );
      router.push({
        path: "/warein-batch-receive",
        query: {
          selectedList: JSON.stringify(selectedItems),
          source: "wareIn",
          back: "/warein-receive?status=pending",
        },
      });
    };

    const handleTypeFilterChange = () => {
      selectedIds.value = [];
      fetchPage({ resetPage: true });
    };

    const handleSortFieldChange = () => {
      selectedIds.value = [];
      fetchPage({ resetPage: true });
    };

    const handleTimeFilterChange = () => {
      selectedIds.value = [];
      fetchPage({ resetPage: true });
    };

    const openReceiveDetailById = async (id) => {
      if (!id) return;
      detailVisible.value = true;
      detailLoading.value = true;
      detailError.value = "";
      detailData.value = null;
      try {
        const res = await getWareInReceiveDetail(id);
        detailData.value = res?.data || null;
        console.log("详情数据:", detailData.value);
      } catch (e) {
        detailError.value = e?.message || "加载失败";
      } finally {
        detailLoading.value = false;
      }
    };

    const closeDetail = () => {
      detailVisible.value = false;
      if (needRefreshAfterCollect.value) {
        needRefreshAfterCollect.value = false;
        fetchPage({ resetPage: true });
      }
    };

    const confirmSubmitting = ref(false);

    const submitting = computed(
      () => confirmSubmitting.value || collectSubmitting.value,
    );

    const handleConfirmReceive = async () => {
      if (confirmSubmitting.value) return;
      try {
        await ElMessageBox.confirm("确认收货完成？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        try {
          const wareInId = detailData.value?.id || detailData.value?.wareInId;
          if (!wareInId) throw new Error("缺少入库单ID");

          confirmSubmitting.value = true;
          await confirmWareInCollect(wareInId);
          toast.success("收货完成成功");
          closePalletPage();
          await fetchPage({ resetPage: true });
          closeDetail();
        } catch (e) {
          toast.error(e?.message || "收货完成失败");
        } finally {
          confirmSubmitting.value = false;
        }
      } catch (e) {
        if (e !== "cancel") {
          toast.error(e?.message || "收货失败");
        }
      }
    };

    const selectedMaterial = ref(null);
    const palletMaterial = computed(
      () =>
        selectedMaterial.value ||
        detailData.value?.wareInDetailList?.[0] ||
        null,
    );

    const materialCollectedQty = (m) => {
      const records = m?.recordVOList || m?.wareInDetailRecordVOList || [];
      const list = Array.isArray(records) ? records : [];
      return list.reduce(
        (sum, r) => sum + parseFloatSafe(r?.wareInNum || r?.zeroNum),
        0,
      );
    };

    const isMaterialDone = (m) => {
      const total = parseFloatSafe(m?.comeNum || m?.wareInNum);
      const done = materialCollectedQty(m);
      return total > 0 && done >= total - 1e-6;
    };

    const palletReadonly = computed(() => {
      if (activeTab.value === "done") return true;
      const m = selectedMaterial.value;
      if (!m) return false;
      return isMaterialDone(m);
    });

    const existingPalletRecords = computed(() => {
      const list =
        palletMaterial.value?.recordVOList ||
        palletMaterial.value?.wareInDetailRecordVOList ||
        [];
      return Array.isArray(list) ? list : [];
    });

    const existingCollectedQty = computed(() => {
      return existingPalletRecords.value.reduce(
        (sum, r) => sum + parseFloatSafe(r?.wareInNum || r?.zeroNum),
        0,
      );
    });

    const palletMaxQty = computed(() => {
      const fromDetail = palletMaterial.value?.palletNum;
      if (fromDetail !== null && fromDetail !== undefined && fromDetail !== "")
        return fromDetail;
      const first = supplierStockList.value?.[0];
      return (
        first?.palletNum ||
        first?.singlePalletMaxNum ||
        first?.maxPalletNum ||
        "-"
      );
    });

    const totalComeQty = computed(() =>
      parseFloatSafe(
        palletMaterial.value?.comeNum || palletMaterial.value?.wareInNum,
      ),
    );
    const allocatedQty = computed(() =>
      palletItems.value.reduce(
        (sum, item) => sum + parseFloatSafe(item.qty),
        0,
      ),
    );
    const remainingQty = computed(() => {
      const r =
        totalComeQty.value - existingCollectedQty.value - allocatedQty.value;
      return r > 0 ? r : 0;
    });

    const isOpening = (materialId) => {
      if (!materialId) return false;
      return palletOpeningMap.value[materialId] || false;
    };

    const openPalletPage = async (materialItem) => {
      if (
        Number(detailData.value?.materialVersionStatus) === 1 &&
        !isMaterialDone(materialItem)
      ) {
        ElMessage.warning("多版本物料不支持扫码归托，请使用多物料多托盘");
        return;
      }

      const materialId = materialItem?.id;
      if (materialId) {
        palletOpeningMap.value[materialId] = true;
      }

      const supplierId = detailData.value?.supplierId;
      selectedMaterial.value = materialItem || null;

      try {
        const wareInId = detailData.value?.id || detailData.value?.wareInId;
        if (wareInId) {
          const res = await getWareInReceiveDetail(wareInId);
          detailData.value = res?.data || detailData.value;
        }
      } catch {
        // ignore
      }

      palletVisible.value = true;
      palletLoading.value = true;
      palletError.value = "";
      palletInfoCollapsed.value = true;
      collectType.value = 0;
      supplierStockList.value = [];
      palletCode.value = "";
      palletQty.value = "";
      palletItems.value = [];

      // 打印调试信息
      console.log("🔧 打开托盘页面，当前仓库设置:", getWarehouseSettings());
      console.log(
        "🔧 localStorage.warehouseSettings:",
        localStorage.getItem("warehouseSettings"),
      );

      try {
        if (!supplierId) {
          throw new Error("缺少 supplierId");
        }
        const res = await getWareInSupplierStockList(supplierId);
        supplierStockList.value = res?.data || res?.data?.records || [];
      } catch (e) {
        palletError.value = e?.message || "加载失败";
      } finally {
        palletLoading.value = false;
        if (materialId) {
          palletOpeningMap.value[materialId] = false;
        }
        setDefaultPalletQty();
        loadZXingWasmReader();
        nextTick(() => {
          focusPalletCodeInput();

          // 直接给DOM元素添加原生事件监听，不依赖Vue！
          const inputEl = getPalletCodeNativeInput();
          if (inputEl && !inputEl._pdaListeners) {
            console.log("🎯 给DOM元素添加原生事件监听");

            // 监听所有可能的事件
            const handleAnyEvent = (e) => {
              console.log("🎯 DOM事件:", {
                type: e.type,
                key: e.key,
                keyCode: e.keyCode,
                which: e.which,
                inputType: e.inputType,
                data: e.data,
                value: e.target.value,
              });

              // 如果是回车或有换行符，立即处理
              if (
                e.key === "Enter" ||
                e.keyCode === 13 ||
                /[\n\r]/.test(e.target.value)
              ) {
                e.preventDefault();
                e.stopPropagation();
                processPdaInput(e.target.value);
              }
            };

            inputEl.addEventListener("input", handleAnyEvent, true);
            inputEl.addEventListener("keydown", handleAnyEvent, true);
            inputEl.addEventListener("keyup", handleAnyEvent, true);
            inputEl.addEventListener("keypress", handleAnyEvent, true);
            inputEl.addEventListener("compositionend", handleAnyEvent, true);
            inputEl.addEventListener("change", handleAnyEvent, true);
            inputEl.addEventListener("paste", handleAnyEvent, true);
            inputEl.addEventListener(
              "blur",
              (e) => {
                if (e.target.value) {
                  processPdaInput(e.target.value);
                }
              },
              true,
            );

            // 保存监听器引用以便清理
            inputEl._pdaListeners = true;
          }
        });
      }
    };

    // 处理PDA输入的通用函数
    let pdaLastProcessTime = 0;
    const processPdaInput = (rawValue) => {
      console.log("🎯 processPdaInput 被调用:", JSON.stringify(rawValue));

      if (!rawValue) return;

      // 检查设置
      const warehouseSettings = getWarehouseSettings();
      if (!warehouseSettings.autoAddPallet) return;

      // 防抖：200ms内只处理一次
      const now = Date.now();
      if (now - pdaLastProcessTime < 200) {
        console.log("🎯 防抖，跳过");
        return;
      }
      pdaLastProcessTime = now;

      // 提取托盘码（去除换行/回车等特殊字符）
      let code = normalizePalletCode(rawValue);
      if (!code) {
        // 再尝试：提取第一个换行符前的内容
        const match = rawValue.match(/^([^\n\r]+)/);
        if (match && match[1]) {
          code = normalizePalletCode(match[1]);
        }
      }

      if (!code) {
        console.log("🎯 没有有效的托盘码");
        return;
      }

      console.log("🎯 准备添加托盘:", code);

      // 清空输入框
      palletCode.value = "";
      clearPalletCodeSearch();

      // 添加托盘
      applyScannedPalletCode(code);
    };

    const handlePalletCodeSearch = async (keyword) => {
      const seq = palletSearchSeq.value + 1;
      palletSearchSeq.value = seq;

      const kw = String(keyword || "").trim();
      if (!kw) {
        palletSearchOptions.value = [];
        return;
      }

      palletSearchLoading.value = true;
      try {
        const res = await getPalletCodeList({ palletCode: kw });
        if (seq !== palletSearchSeq.value) return;
        const data = res?.data;
        palletSearchOptions.value = Array.isArray(data) ? data : [];
      } catch (e) {
        if (seq !== palletSearchSeq.value) return;
        palletSearchOptions.value = [];
      } finally {
        if (seq === palletSearchSeq.value) {
          palletSearchLoading.value = false;
        }
      }
    };

    const handlePalletSelectFromSearch = (val) => {
      const code = normalizePalletCode(val || "");
      if (!code) {
        palletCode.value = "";
        return;
      }
      palletCode.value = code;
    };

    const clearPalletCodeSearch = () => {
      palletCode.value = "";
      palletSearchOptions.value = [];
    };

    const handlePalletSelectVisible = (visible) => {
      if (!visible) return;
      // 下拉打开时，尽量把焦点放到可输入框，方便扫码枪/键盘输入
      nextTick(() => {
        getPalletCodeNativeInput()?.focus?.();
      });
    };

    const closePalletPage = () => {
      stopMobileScan();
      palletVisible.value = false;
      if (needRefreshAfterCollect.value && !detailVisible.value) {
        needRefreshAfterCollect.value = false;
        fetchPage({ resetPage: true });
      }
    };

    const palletInfoCollapsed = ref(true);
    const togglePalletInfoCollapse = () => {
      palletInfoCollapsed.value = !palletInfoCollapsed.value;
    };

    const collectSubmitting = ref(false);

    const needRefreshAfterCollect = ref(false);

    const collectType = ref(0);

    const leftoverStockList = ref([]);
    const leftoverSelected = ref(null);

    const loadLeftoverStockList = async () => {
      const wareInId = detailData.value?.id || detailData.value?.wareInId;
      const materialId = palletMaterial.value?.materialId;
      if (!wareInId || !materialId) throw new Error("缺少入库单ID或物料ID");

      const res = await getWareInMaterialStockList({ wareInId, materialId });
      const arr = res?.data || [];
      const list = Array.isArray(arr) ? arr : [];
      leftoverStockList.value = list;
      leftoverSelected.value = list[0] || null;
    };

    const selectLeftoverPallet = (row) => {
      leftoverSelected.value = row || null;
    };

    const selectLeftover = async () => {
      collectType.value = 1;
      stopMobileScan();
      palletCode.value = "";
      palletQty.value = "";
      palletItems.value = [];
      scanError.value = "";
      leftoverStockList.value = [];
      leftoverSelected.value = null;
      palletLoading.value = true;
      palletError.value = "";
      try {
        await loadLeftoverStockList();
        toast.default("已切换为零头托模式");
      } catch (e) {
        palletError.value = e?.message || "加载零头托托盘失败";
      } finally {
        palletLoading.value = false;
      }
    };

    const cancelLeftover = () => {
      collectType.value = 0;
      scanError.value = "";
      leftoverStockList.value = [];
      leftoverSelected.value = null;
      nextTick(() => {
        focusPalletCodeInput();
      });
    };

    const getCollectBase = () => {
      const wareInId = detailData.value?.id || detailData.value?.wareInId;
      const materialId = palletMaterial.value?.materialId;
      const materialGroupId = palletMaterial.value?.materialGroupId;

      if (!wareInId) throw new Error("缺少 wareInId");
      if (!materialId) throw new Error("缺少 materialId");
      // if (!materialGroupId) throw new Error('缺少 materialGroupId')

      return { wareInId, materialId, materialGroupId };
    };

    const showCollectError = (msg) => {
      collectErrorMsg.value = msg || "操作失败";
      collectErrorVisible.value = true;
    };

    const closeCollectError = () => {
      collectErrorVisible.value = false;
    };

    const refreshAfterCollect = async () => {
      try {
        if (detailVisible.value) {
          const wareInId = detailData.value?.id || detailData.value?.wareInId;
          if (wareInId) {
            const res = await getWareInReceiveDetail(wareInId);
            detailData.value = res?.data || detailData.value;
          }
        }
      } catch {
        // ignore
      }

      await fetchPage({ resetPage: true });
    };

    const handleFinishCollect = async () => {
      if (collectSubmitting.value) return;
      if (palletReadonly.value) return;

      let confirmMsg = "确认完成归托？";
      if (remainingQty.value > 0) {
        confirmMsg = `已归托 ${(
          totalComeQty.value - remainingQty.value
        ).toFixed(3)} 个，还剩 ${remainingQty.value.toFixed(
          3,
        )} 个未归托，确定要继续提交吗？`;
      }

      try {
        await ElMessageBox.confirm(confirmMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        try {
          palletError.value = "";

          const base = getCollectBase();
          let wareInDetailRecordVOList = [];

          if (collectType.value === 1) {
            if (remainingQty.value <= 0) {
              throw new Error("无剩余数量，无需零头托");
            }
            const selected = leftoverSelected.value;
            if (
              !selected?.palletId ||
              !selected?.wareId ||
              !selected?.storeId
            ) {
              throw new Error("请选择托盘");
            }
            wareInDetailRecordVOList = [
              {
                ...selected,
                wareInNum: Number(remainingQty.value.toFixed(3)),
              },
            ];
          } else {
            if (!palletItems.value.length) {
              throw new Error("请先添加托盘");
            }
            wareInDetailRecordVOList = palletItems.value.map((p) => ({
              wareInNum: parseFloatSafe(p.qty),
              palletCode: normalizePalletCode(p.code),
            }));
          }

          collectSubmitting.value = true;
          await collectWareIn({
            ...base,
            wareInDetailRecordVOList,
            type: collectType.value,
          });

          toast.success("完成归托成功");
          needRefreshAfterCollect.value = true;
          closePalletPage();
          await refreshAfterCollect();
        } catch (e) {
          const msg = e?.message || "完成归托失败";
          showCollectError(msg);
        } finally {
          collectSubmitting.value = false;
        }
      } catch (e) {
        if (e !== "cancel") {
          const msg = e?.message || "归托失败";
          showCollectError(msg);
        }
      }
    };

    const handlePalletInputChange = () => {
      console.log("🔍 handlePalletInputChange 被调用");
      if (palletComposing.value) return;
      const raw = String(palletCode.value ?? "");
      console.log("🔍 当前输入内容:", JSON.stringify(raw));

      // 清除之前的定时器
      if (autoAddTimeout) {
        clearTimeout(autoAddTimeout);
        autoAddTimeout = null;
      }

      if (!raw) return;

      // 兼容扫码枪：常见会带回车换行
      const m = raw.match(/[\n\r]/);
      if (m && typeof m.index === "number") {
        const first = normalizePalletCode(raw.substring(0, m.index));
        console.log("🔍 PDA扫码检测到换行符，处理托盘码:", first);

        if (first) {
          // 清空输入框
          palletCode.value = "";
          // 统一使用 applyScannedPalletCode 处理，包含完整逻辑
          applyScannedPalletCode(first);
        }
        return;
      }

      // 手动输入：仅当存在不可见字符时才清洗，避免频繁改写影响光标
      const normalized = normalizePalletCode(raw);
      if (normalized !== raw) {
        palletCode.value = normalized;
      }

      // 如果有内容，设置定时器在150ms后自动添加（适配不带换行符的PDA）
      if (normalized) {
        const warehouseSettings = getWarehouseSettings();
        if (warehouseSettings.autoAddPallet) {
          console.log("⏰ 设置自动添加定时器，150ms后执行");
          autoAddTimeout = setTimeout(() => {
            console.log("⏰ 自动添加定时器触发，托盘码:", normalized);
            // 确认输入框内容是否仍然是这个码
            if (normalizePalletCode(palletCode.value ?? "") === normalized) {
              palletCode.value = "";
              applyScannedPalletCode(normalized);
            }
            autoAddTimeout = null;
          }, 150);
        }
      }
    };

    const handlePalletCompositionStart = () => {
      palletComposing.value = true;
    };

    const handlePalletCompositionEnd = () => {
      palletComposing.value = false;
      // IME 结束后再做一次清洗/自动添加（避免安卓输入法导致“乱码/光标跳动”）
      handlePalletInputChange();
    };

    const startScan = () => {
      palletScanVisible.value = true;
    };

    const handleScanSuccess = (decodedText) => {
      const text = String(decodedText || "")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/[\r\n\t]/g, "")
        .trim();

      if (!text) return;

      palletCode.value = text;
      palletScanVisible.value = false;
    };

    const handlePalletEnter = (e) => {
      e.preventDefault();
      console.log("🔍 回车键被触发");
      const code = normalizePalletCode(palletCode.value ?? "");
      console.log("🔍 当前托盘码:", code);

      if (!code) return;

      // 清除定时器
      if (autoAddTimeout) {
        clearTimeout(autoAddTimeout);
        autoAddTimeout = null;
      }

      // 清空输入框
      palletCode.value = "";
      // 统一使用 applyScannedPalletCode 处理，包含完整逻辑
      applyScannedPalletCode(code);
    };

    const handlePalletBlur = () => {
      console.log("🔍 输入框失去焦点");
      const code = normalizePalletCode(palletCode.value ?? "");
      console.log("🔍 失去焦点时的托盘码:", code);

      if (!code) return;

      // 清除定时器
      if (autoAddTimeout) {
        clearTimeout(autoAddTimeout);
        autoAddTimeout = null;
      }

      const warehouseSettings = getWarehouseSettings();
      if (warehouseSettings.autoAddPallet) {
        console.log("✅ 失去焦点自动添加模式 - 调用 addPallet:", code);
        // 清空输入框
        palletCode.value = "";
        // 统一使用 applyScannedPalletCode 处理，包含完整逻辑
        applyScannedPalletCode(code);
      }
    };

    const handlePalletPaste = (e) => {
      console.log("🔍 粘贴事件被触发");
      const pastedText = (e.clipboardData || window.clipboardData).getData(
        "text",
      );
      console.log("🔍 粘贴的内容:", JSON.stringify(pastedText));

      if (!pastedText) return;

      // 阻止默认粘贴
      e.preventDefault();

      // 清除定时器
      if (autoAddTimeout) {
        clearTimeout(autoAddTimeout);
        autoAddTimeout = null;
      }

      const code = normalizePalletCode(pastedText);
      if (code) {
        console.log("✅ 粘贴自动添加模式 - 调用 addPallet:", code);
        // 清空输入框
        palletCode.value = "";
        // 统一使用 applyScannedPalletCode 处理，包含完整逻辑
        applyScannedPalletCode(code);
      }
    };

    const prepareLeftover = () => {
      const r = remainingQty.value;
      if (r <= 0) return;
      palletQty.value = String(Number(r.toFixed(3)));
      nextTick(() => {
        focusPalletCodeInput();
      });
    };

    const applyScannedPalletCode = (rawCode) => {
      console.log("🔍 applyScannedPalletCode 被调用，原始码:", rawCode);
      collectType.value = 0;
      const code = normalizePalletCode(rawCode ?? "");
      console.log("🔍 标准化后的托盘码:", code);
      if (!code) return;

      const dup =
        palletItems.value.some(
          (p) => normalizePalletCode(p.code || "") === code,
        ) ||
        existingPalletRecords.value.some(
          (r) => normalizePalletCode(r?.palletCode || "") === code,
        );
      if (dup) {
        console.log("❌ 托盘码已存在:", code);
        toast.error("托盘码已存在");
        return;
      }

      const warehouseSettings = getWarehouseSettings();
      console.log("🔧 获取到的仓库设置:", warehouseSettings);

      if (warehouseSettings.autoAddPallet) {
        console.log("✅ 自动添加模式 - 调用 addPallet:", code);
        // 自动添加托盘
        addPallet(code);
      } else {
        console.log("👆 手动模式 - 填入代码等待用户操作:", code);
        // 手动模式：只填入代码，等待用户点击添加
        palletCode.value = code;
        const currentQty = parseFloatSafe(palletQty.value);
        if (!currentQty || currentQty <= 0) {
          setDefaultPalletQty();
        }
        nextTick(() => {
          focusPalletCodeInput();
        });
      }
    };

    const addPallet = (codeFromScan) => {
      console.log("📦 addPallet 被调用，参数:", codeFromScan);
      collectType.value = 0;
      const isEvent = !!(
        codeFromScan &&
        typeof codeFromScan === "object" &&
        (typeof codeFromScan.preventDefault === "function" ||
          typeof codeFromScan.stopPropagation === "function")
      );
      const code = normalizePalletCode(
        (isEvent ? "" : codeFromScan) ?? palletCode.value ?? "",
      );
      console.log("📦 处理后的托盘码:", code, "是否事件:", isEvent);
      if (!code) return;

      const dup =
        palletItems.value.some(
          (p) => normalizePalletCode(p.code || "") === code,
        ) ||
        existingPalletRecords.value.some(
          (r) => normalizePalletCode(r?.palletCode || "") === code,
        );
      if (dup) {
        toast.error("托盘码已存在");
        palletCode.value = "";
        nextTick(() => {
          focusPalletCodeInput();
        });
        return;
      }

      const maxQty = parseFloatSafe(palletMaxQty.value);
      const remain = remainingQty.value;
      if (remain <= 0) return;

      let qty = parseFloatSafe(palletQty.value);
      if (!qty || qty <= 0) {
        qty = maxQty > 0 ? Math.min(maxQty, remain) : remain;
      }
      if (qty > remain) qty = remain;

      palletItems.value.push({ code, qty });
      console.log("✅ 托盘成功添加到列表:", { code, qty });
      console.log("📋 当前托盘列表:", palletItems.value);
      palletCode.value = "";
      setDefaultPalletQty();
      nextTick(() => {
        focusPalletCodeInput();
      });
    };

    const removePallet = (idx) => {
      palletItems.value.splice(idx, 1);
      nextTick(() => {
        setDefaultPalletQty();
      });
    };

    const setDefaultPalletQty = () => {
      const maxQty = parseFloatSafe(palletMaxQty.value);
      const remain = remainingQty.value;
      if (remain <= 0) {
        palletQty.value = "";
        return;
      }
      if (maxQty > 0) {
        palletQty.value = String(Number(Math.min(maxQty, remain).toFixed(3)));
        return;
      }
      palletQty.value = String(Number(remain.toFixed(3)));
    };

    const openPhotoScan = () => {
      palletFileInput.value?.click?.();
    };

    const handlePalletFileChange = async (e) => {
      const file = e?.target?.files?.[0];
      if (!file) return;

      const type = (file.type || "").toLowerCase();
      if (type.includes("heic") || type.includes("heif")) {
        scanError.value =
          "当前照片格式为 HEIC/HEIF，网页端无法识别。请在 iPhone 设置 -> 相机 -> 格式 -> 选择“最兼容(JPEG)”后重试。";
        nextTick(() => {
          focusPalletCodeInput();
        });
        if (e?.target) e.target.value = "";
        return;
      }

      recognizing.value = true;
      try {
        let decodedText = "";
        let html5ErrorMsg = "";
        const scanner = new Html5Qrcode("pallet-scan-file-region");

        try {
          // html5-qrcode 不同版本方法名不同，兼容处理
          if (typeof scanner.scanFileV2 === "function") {
            const res = await scanner.scanFileV2(file, true);
            decodedText = res?.decodedText || res?.text || "";
          } else if (typeof scanner.scanFile === "function") {
            decodedText = await scanner.scanFile(file, true);
          }
        } catch (err) {
          html5ErrorMsg = err?.message || "";
        }

        if (!decodedText) {
          decodedText = await decodeQrByJsQR(file);
        }

        try {
          await scanner.clear();
        } catch {
          // ignore
        }

        if (decodedText) {
          const normalized = String(decodedText)
            .replace(/[\u200B-\u200D\uFEFF]/g, "")
            .replace(/[\r\n\t]/g, "")
            .trim();

          scanError.value = "";
          showScanSuccess("识别成功");
          applyScannedPalletCode(normalized);
        } else {
          const msg = html5ErrorMsg || "未识别到条码/二维码";
          if (msg.includes("No MultiFormat Readers")) {
            scanError.value =
              "未识别到托盘码：拍照时请尽量让二维码占画面 1/3 以上、避免反光并对焦。若二维码是在屏幕上，强烈建议用截图上传（成功率更高）。";
          } else {
            scanError.value =
              "未识别到托盘码：请重拍/改用截图上传，或直接在输入框手动输入托盘码。";
          }

          nextTick(() => {
            focusPalletCodeInput();
          });
        }
      } finally {
        recognizing.value = false;
      }

      // 允许同一张图重复选择
      if (e?.target) e.target.value = "";
    };

    const startMobileScan = async () => {
      if (!navigator.mediaDevices?.getUserMedia) {
        scanError.value = "当前浏览器不支持摄像头访问";
        return;
      }

      await stopMobileScan();
      cameraVisible.value = true;
      scanError.value = "";
      scanSuccessLocked.value = false;
      recognizing.value = false;

      if (scanFallbackTimer.value) {
        window.clearTimeout(scanFallbackTimer.value);
        scanFallbackTimer.value = 0;
      }

      try {
        await nextTick();
        const regionId = "pallet-scan-region";
        clearScanRegion(regionId);

        if (!isIOS()) {
          // 提速优先：支持则走原生 BarcodeDetector / ZXing WASM
          // 但部分安卓 WebView 识别不稳定，因此加一个短超时兜底切换到 html5-qrcode。
          try {
            const started = await startNativeBarcodeDetector(regionId);
            if (started) {
              scanFallbackTimer.value = window.setTimeout(async () => {
                if (!cameraVisible.value) return;
                if (scanSuccessLocked.value) return;
                scanError.value = "识别较慢，已切换兼容模式...";
                stopNativeBarcodeDetector();
                stopZXingWasmDetector();
                // 继续走 html5-qrcode
                try {
                  clearScanRegion(regionId);
                  const scanner = new Html5Qrcode(regionId);
                  html5Qrcode.value = scanner;
                  await withTimeout(
                    scanner.start(
                      { facingMode: "environment" },
                      {
                        fps: 18,
                        qrbox: { width: 220, height: 220 },
                        formatsToSupport: [
                          Html5QrcodeSupportedFormats.QR_CODE,
                          Html5QrcodeSupportedFormats.CODE_128,
                          Html5QrcodeSupportedFormats.ITF,
                        ],
                        experimentalFeatures: {
                          useBarCodeDetectorIfSupported: true,
                        },
                      },
                      (decodedText) => {
                        if (!decodedText) return;
                        if (scanSuccessLocked.value) return;
                        scanSuccessLocked.value = true;
                        recognizing.value = true;
                        try {
                          applyScannedPalletCode(decodedText);
                          showScanSuccess("识别成功");
                          recognizing.value = false;
                          window.setTimeout(() => {
                            stopMobileScan();
                          }, 0);
                        } catch (e) {
                          scanError.value = e?.message || "处理托盘码失败";
                          recognizing.value = false;
                          scanSuccessLocked.value = false;
                        }
                      },
                      () => {},
                    ),
                    8000,
                  );
                } catch {
                  // ignore
                }
              }, 3500);
              return;
            }
          } catch {
            // ignore and fallback to html5-qrcode
          }

          try {
            const started = await startZXingWasmDetector(regionId);
            if (started) {
              scanFallbackTimer.value = window.setTimeout(async () => {
                if (!cameraVisible.value) return;
                if (scanSuccessLocked.value) return;
                scanError.value = "识别较慢，已切换兼容模式...";
                stopNativeBarcodeDetector();
                stopZXingWasmDetector();
                // 兼容模式仍由下方 html5-qrcode 继续
                try {
                  clearScanRegion(regionId);
                  const scanner = new Html5Qrcode(regionId);
                  html5Qrcode.value = scanner;
                  await withTimeout(
                    scanner.start(
                      { facingMode: "environment" },
                      {
                        fps: 18,
                        qrbox: { width: 220, height: 220 },
                        formatsToSupport: [
                          Html5QrcodeSupportedFormats.QR_CODE,
                          Html5QrcodeSupportedFormats.CODE_128,
                          Html5QrcodeSupportedFormats.ITF,
                        ],
                        experimentalFeatures: {
                          useBarCodeDetectorIfSupported: true,
                        },
                      },
                      (decodedText) => {
                        if (!decodedText) return;
                        if (scanSuccessLocked.value) return;
                        scanSuccessLocked.value = true;
                        recognizing.value = true;
                        try {
                          applyScannedPalletCode(decodedText);
                          showScanSuccess("识别成功");
                          recognizing.value = false;
                          window.setTimeout(() => {
                            stopMobileScan();
                          }, 0);
                        } catch (e) {
                          scanError.value = e?.message || "处理托盘码失败";
                          recognizing.value = false;
                          scanSuccessLocked.value = false;
                        }
                      },
                      () => {},
                    ),
                    8000,
                  );
                } catch {
                  // ignore
                }
              }, 3500);
              return;
            }
          } catch {
            // ignore and fallback to html5-qrcode
          }
        }

        clearScanRegion(regionId);
        const scanner = new Html5Qrcode(regionId);
        html5Qrcode.value = scanner;

        await withTimeout(
          scanner.start(
            { facingMode: "environment" },
            {
              fps: 18,
              qrbox: { width: 220, height: 220 },
              // 提速：缩小格式集合（托盘码通常为二维码/Code128/ITF）
              formatsToSupport: [
                Html5QrcodeSupportedFormats.QR_CODE,
                Html5QrcodeSupportedFormats.CODE_128,
                Html5QrcodeSupportedFormats.ITF,
              ],
              // 提速：可用时走原生 BarcodeDetector
              experimentalFeatures: {
                useBarCodeDetectorIfSupported: true,
              },
            },
            (decodedText) => {
              if (!decodedText) return;
              if (scanSuccessLocked.value) return;
              scanSuccessLocked.value = true;
              recognizing.value = true;
              try {
                applyScannedPalletCode(decodedText);
                showScanSuccess("识别成功");
                recognizing.value = false;
                window.setTimeout(() => {
                  stopMobileScan();
                }, 0);
              } catch (e) {
                scanError.value = e?.message || "处理托盘码失败";
                recognizing.value = false;
                scanSuccessLocked.value = false;
              }
            },
            () => {
              // ignore scan failure callback spam
            },
          ),
          8000,
        );
      } catch (e) {
        scanError.value =
          e?.message === "timeout"
            ? "相机启动超时"
            : e?.message || "无法打开相机";
        await stopMobileScan();
      }
    };

    const stopMobileScan = async () => {
      cameraVisible.value = false;
      recognizing.value = false;

      if (scanFallbackTimer.value) {
        window.clearTimeout(scanFallbackTimer.value);
        scanFallbackTimer.value = 0;
      }

      if (stopScanInProgress.value) return stopScanPromise.value;
      stopScanInProgress.value = true;

      stopScanPromise.value = (async () => {
        stopNativeBarcodeDetector();
        stopZXingWasmDetector();
        const scanner = html5Qrcode.value;
        html5Qrcode.value = null;
        if (!scanner) return;

        try {
          await withTimeout(scanner.stop(), 1500);
        } catch {
          // ignore
        }

        try {
          await withTimeout(scanner.clear(), 1500);
        } catch {
          // ignore
        }

        clearScanRegion("pallet-scan-region");
      })().finally(() => {
        stopScanInProgress.value = false;
        scanSuccessLocked.value = false;
      });

      return stopScanPromise.value;
    };

    const openWareModal = async () => {
      const supplierId =
        detailData.value?.supplierId || selectedSupplier.value?.id;
      if (!supplierId) {
        toast.error("缺少供应商信息");
        return;
      }
      wareModalVisible.value = true;
      wareLoading.value = true;
      wareList.value = [];
      try {
        const res = await getSupplierWare(supplierId);
        wareList.value = res?.data || [];
      } catch (e) {
        console.error("获取供应商库位失败:", e);
        toast.error(e?.message || "获取库位失败");
      } finally {
        wareLoading.value = false;
      }
    };

    const closeWareModal = () => {
      wareModalVisible.value = false;
    };

    onMounted(() => {
      viewportBaseHeight = window?.visualViewport?.height || window.innerHeight;
      const updateKeyboardState = () => {
        const h = window?.visualViewport?.height || window.innerHeight;
        const base = viewportBaseHeight || h;
        keyboardVisible.value = base - h > 120;
      };

      if (window?.visualViewport?.addEventListener) {
        const vv = window.visualViewport;
        vv.addEventListener("resize", updateKeyboardState);
        vv.addEventListener("scroll", updateKeyboardState);
        removeViewportListener = () => {
          vv.removeEventListener("resize", updateKeyboardState);
          vv.removeEventListener("scroll", updateKeyboardState);
        };
      } else {
        window.addEventListener("resize", updateKeyboardState);
        removeViewportListener = () =>
          window.removeEventListener("resize", updateKeyboardState);
      }

      updateKeyboardState();
      nextTick(() => {
        window.scrollTo(0, 0);
      });

      const receiptId = route.query?.receiptId;
      if (receiptId) {
        openReceiveDetailById(receiptId);
      }

      const userInfo = getUicAuthUserInfo();
      createBizDept.value = userInfo?.deptId || "";

      // 添加调试函数到全局
      window.debugPDAScan = () => {
        console.log("🧪 手动测试PDA扫码");
        const testCode = "TEST001\n";
        palletCode.value = testCode;
        handlePalletInputChange();
      };

      window.debugSettings = () => {
        console.log("🔧 当前仓库设置:", getWarehouseSettings());
      };
    });

    onBeforeUnmount(() => {
      if (typeof removeViewportListener === "function") {
        removeViewportListener();
      }
      removeViewportListener = null;
    });

    // 监听托盘码变化，只要有值就自动添加！
    let lastAutoAddTime = 0;
    watch(
      () => palletCode.value,
      (newVal) => {
        if (!newVal) return;

        console.log("🎯 palletCode变化:", JSON.stringify(newVal));

        // 检查设置
        const warehouseSettings = getWarehouseSettings();
        if (!warehouseSettings.autoAddPallet) return;

        // 检测是否包含换行符/回车符
        const hasNewline = /[\n\r]/.test(newVal);
        if (hasNewline) {
          console.log("🎯 检测到换行/回车字符！");
          // 提取第一个换行符前的内容
          const match = newVal.match(/^([^\n\r]+)/);
          if (match && match[1]) {
            const code = normalizePalletCode(match[1]);
            if (code) {
              console.log("🎯 提取到托盘码:", code);
              // 防抖：100ms内只添加一次
              const now = Date.now();
              if (now - lastAutoAddTime < 100) return;
              lastAutoAddTime = now;

              // 立即清空输入框并添加
              palletCode.value = "";
              applyScannedPalletCode(code);
              return;
            }
          }
        }

        // 即使没有换行符，有内容也自动添加
        const code = normalizePalletCode(newVal);
        if (!code) return;

        // 防抖：100ms内只添加一次
        const now = Date.now();
        if (now - lastAutoAddTime < 100) return;
        lastAutoAddTime = now;

        console.log("🎯 托盘码变化，自动添加:", code);

        // 立即清空输入框并添加
        palletCode.value = "";
        applyScannedPalletCode(code);
      },
    );

    watch(
      () => route.query?.receiptId,
      (v) => {
        if (v) {
          openReceiveDetailById(v);
        }
      },
    );

    watch(
      () => route.query?.create,
      (v) => {
        if (String(v) === "1") {
          openCreate();
        }
      },
      { immediate: true },
    );

    onMounted(() => {
      const status = route.query?.status;
      if (status === "pending") {
        activeTab.value = "pending";
      } else if (status === "done") {
        activeTab.value = "done";
      } else if (status === "todo") {
        activeTab.value = "todo";
      }

      sortField.value =
        activeTab.value === "done" ? "wareInTime" : "materialNo";

      restoreSupplierFromRoute();
      fetchPage({ resetPage: true });
    });

    const restoreSupplierFromRoute = () => {
      const supplierNameParam = route.query?.supplierName;
      const supplierIdParam = route.query?.supplierId;

      if (supplierIdParam) {
        selectedSupplier.value = {
          id: supplierIdParam,
          supplierName: supplierNameParam || "",
        };
        selectedSupplierId.value = supplierIdParam;
        supplierList.value = [
          { id: supplierIdParam, supplierName: supplierNameParam || "" },
        ];
        if (supplierNameParam) {
          supplierKeyword.value = supplierNameParam;
        }
        supplierDropdown.value = false;
      }

      const nk = route.query?.noKeyword;
      const ns = route.query?.noSearchType;
      if (nk) noKeyword.value = decodeURIComponent(nk);
      if (ns) noSearchType.value = ns;
    };

    watch(
      [
        () => route.query?.supplierId,
        () => route.query?.supplierName,
        () => route.query?.noKeyword,
        () => route.query?.noSearchType,
        () => route.query?.status,
      ],
      () => {
        restoreSupplierFromRoute();
        const status = route.query?.status;
        if (status === "pending") {
          activeTab.value = "pending";
        } else if (status === "done") {
          activeTab.value = "done";
        } else if (status === "todo") {
          activeTab.value = "todo";
        }
        sortField.value =
          activeTab.value === "done" ? "wareInTime" : "materialNo";
        fetchPage({ resetPage: true });
      },
    );

    return {
      handleCreate,
      tabOptions,
      handleTabChange,
      keyboardVisible,
      handleDistribute,
      supplierKeyword,
      supplierLoading,
      supplierDropdown,
      supplierList,
      selectedSupplier,
      selectedSupplierId,
      handleSupplierSearch,
      handleSupplierChange,
      selectSupplier,
      clearSelectedSupplier,
      closeSupplierDropdown,
      // 单号搜索
      noSearchType,
      noKeyword,
      getNoSearchPlaceholder,
      changeNoSearchType,
      handleNoSearchTypeChange,
      handleNoSearch,
      clearNoSearch,
      hasMultipleKeywords,
      keywordCount,
      createVisible,
      closeCreate,
      createSupplierKeyword,
      createSupplierLoading,
      createSupplierDropdown,
      createSupplierList,
      createSupplier,
      handleCreateSupplierSearch,
      selectCreateSupplier,
      clearCreateSupplier,
      createWareLoading,
      createWareList,
      createStoreId,
      handleCreateWareSelect,
      createDetails,
      openCreateMaterialModal,
      createMaterialVisible,
      closeCreateMaterialModal,
      handleCreateMaterialCancel,
      handleCreateMaterialConfirm,
      createMaterialLoading,
      createMaterialKeyword,
      handleCreateMaterialSearch,
      handleCreateMaterialSearchEnter,
      createMaterialFilteredList,
      createMaterialCurrent,
      createMaterialTotalPages,
      createMaterialList,
      changeCreateMaterialPage,
      addCreateMaterial,
      toggleCreateMaterial,
      truncateMaterialNo,
      isCreateAdded,
      removeCreateDetail,
      normalizeCreateQty,
      calcAfterCreateStock,
      canSubmitCreate,
      createSubmitting,
      submitCreate,
      handleSubmitCreate,
      handleCancelCreate,
      activeTab,
      canRemoveCard,
      list,
      total,
      current,
      totalPages,
      loading,
      statusMsg,
      statusType,
      handleBack,
      goHome,
      switchTab,
      goPrevPage,
      goNextPage,
      isRemoving,
      handleRemoveWareIn,
      formatTime,
      formatDate,
      formatNum,
      formatQty,
      getMaterialNoDisplay,
      hasMultiVersion,
      isDetailMultiVersion,
      canSelectReturnItem,
      versionSelectVisible,
      versionListLoading,
      versionSubmitting,
      versionLoadingId,
      versionList,
      versionParentMaterial,
      selectedVersion,
      selectedVersionId,
      openVersionSelect,
      openVersionSelectFromList,
      closeVersionSelect,
      selectVersion,
      submitVersionSelect,
      openSingleReceive,
      openMultiMaterialMultiPallet,
      multiPalletLoadingId,
      openRedash,
      getTotalWareInNum,
      openReceiveDetail,
      closeDetail,
      handleConfirmReceive,
      detailVisible,
      detailLoading,
      detailError,
      detailData,
      receiveLoading,
      openPalletPage,
      messageVisible,
      messageText,
      messageType,
      closePalletPage,
      processPdaInput,
      palletVisible,
      palletLoading,
      palletError,
      palletInfoCollapsed,
      togglePalletInfoCollapse,
      palletMaterial,
      existingPalletRecords,
      palletMaxQty,
      remainingQty,
      palletCode,
      palletQty,
      palletItems,
      collectType,
      leftoverStockList,
      leftoverSelected,
      palletReadonly,
      isMaterialDone,
      isOpening,
      palletCodeInput,
      palletFileInput,
      palletSearchOptions,
      palletSearchLoading,
      handlePalletCodeSearch,
      handlePalletSelectFromSearch,
      clearPalletCodeSearch,
      handlePalletSelectVisible,
      collectErrorVisible,
      collectErrorMsg,
      closeCollectError,
      failDescExpanded,
      getWareInId,
      handlePalletInputChange,
      handlePalletCompositionStart,
      handlePalletCompositionEnd,
      handlePalletEnter,
      handlePalletBlur,
      handlePalletPaste,
      normalizePalletCode,
      addPallet,
      removePallet,
      prepareLeftover,
      handleFinishCollect,
      collectSubmitting,
      confirmSubmitting,
      getWareInTypeClass,
      isReturnBad,
      isReturnGood,
      selectLeftoverPallet,
      getWareInTypeText,
      submitting,
      selectLeftover,
      cancelLeftover,
      openPhotoScan,
      handlePalletFileChange,
      cameraVisible,
      scanError,
      palletScanVisible,
      startScan,
      handleScanSuccess,
      recognizing,
      scanSuccessVisible,
      scanSuccessMsg,
      showScanSuccess,
      stopScanInProgress,
      html5Qrcode,
      scanSuccessLocked,
      scanFallbackTimer,
      zxingStream,
      zxingRafId,
      zxingVideo,
      zxingCanvas,
      zxingCtx,
      zxingReadBarcodes,
      zxingInFlight,
      barcodeStream,
      barcodeRafId,
      barcodeVideo,
      barcodeDetector,
      barcodeCanvas,
      stopNativeBarcodeDetector,
      startMobileScan,
      stopMobileScan,
      wareModalVisible,
      wareLoading,
      wareList,
      openWareModal,
      closeWareModal,
      handleToggleBad,
      selectedIds,
      toggleSelect,
      hasMultipleMaterials,
      handleBatchReceive,
      wareInTypeFilter,
      sortField,
      timeFilter,
      handleTypeFilterChange,
      handleSortFieldChange,
      handleTimeFilterChange,
      isAllSelected,
      toggleSelectAll,
      selectedSummaryVisible,
      selectedMaterialSummary,
      totalMaterialQty,
      selectedSupplierName,
      openSelectedSummary,
      closeSelectedSummary,
    };
  },
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: var(--background-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
  padding-bottom: 80px;
}

.page-container,
.page-container * {
  box-sizing: border-box;
}

.header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  padding-top: calc(12px + env(safe-area-inset-top));
  background-color: var(--header-background);
  color: var(--header-text);
  box-shadow: 0 2px 8px rgba(35, 177, 192, 0.18);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: calc(56px + env(safe-area-inset-top));
  box-sizing: border-box;
}

.back-btn {
  border: none;
  background: transparent;
  padding: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-back {
  width: 20px;
  height: 20px;
}

.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.title {
  font-size: 17px;
  font-weight: 600;
  color: var(--header-text);
  margin: 0;
}

.header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.header-time-filter {
  height: 30px;
  min-width: 80px;
}

.header-time-filter :deep(.el-select__wrapper) {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  min-height: 30px;
}

.header-time-filter :deep(.el-select__wrapper:hover) {
  border-color: rgba(255, 255, 255, 0.5);
}

.header-time-filter :deep(.el-select__wrapper.is-focus) {
  border-color: rgba(255, 255, 255, 0.6);
  box-shadow: none;
}

.header-time-filter :deep(.el-select__placeholder) {
  color: rgba(255, 255, 255, 0.7);
}

.header-time-filter :deep(.el-select__text) {
  color: #fff;
  font-size: 12px;
}

.header-time-filter :deep(.el-select__caret) {
  color: #fff;
}

.create-btn {
  height: 30px;
  font-size: 12px;
}

.content {
  padding: 8px 10px;
  margin-top: calc(56px + env(safe-area-inset-top));
}

.tabs-segment {
  margin-bottom: 10px;
}

.tabs-segment :deep(.el-segmented) {
  border-radius: 12px !important;
  padding: 3px !important;
}

.tabs-segment :deep(.el-segmented__item) {
  border-radius: 10px !important;
  padding: 8px 0 !important;
  margin: 0 !important;
}

.tabs-segment :deep(.el-segmented__item.is-selected) {
  font-weight: 600;
  border-radius: 10px !important;
}

.light-btn.el-button--primary {
  --el-button-bg-color: #5bc0de !important;
  --el-button-border-color: #5bc0de !important;
  --el-button-hover-bg-color: #46b5d5 !important;
  --el-button-hover-border-color: #46b5d5 !important;
}

.light-btn.el-button--success {
  --el-button-bg-color: #6ecf8e !important;
  --el-button-border-color: #6ecf8e !important;
  --el-button-hover-bg-color: #5cc47e !important;
  --el-button-hover-border-color: #5cc47e !important;
}

.receive-card-header {
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-color);
  flex-wrap: nowrap;
}

.receive-card-header-left {
  flex: 1;
  min-width: 0;
}

.receive-type-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.receive-type {
  color: #ffffff;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  white-space: nowrap;
  flex: 0 0 auto;
}

.receive-type.type-0 {
  background: var(--primary-color);
}

.receive-type.type-1 {
  background: var(--warning-color);
}

.receive-type.type-4 {
  background: var(--success-color);
}

.receive-bad-tag {
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(239, 68, 68, 0.16);
  color: #ef4444;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  flex: 0 0 auto;
}

.receive-good-tag {
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.16);
  color: #22c55e;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  flex: 0 0 auto;
}

.toggle-bad-btn {
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(147, 51, 234, 0.16);
  color: #9333ea;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  border: none;
  cursor: pointer;
  flex: 0 0 auto;
  transition: background 0.2s;
}

.toggle-bad-btn:hover {
  background: rgba(147, 51, 234, 0.24);
}

.receive-create-time {
  font-size: 11px;
  color: var(--text-secondary);
  white-space: nowrap;
}

.receive-no {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
}

.receive-card-body {
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.receive-grid {
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
}

.receive-field {
  display: grid;
  grid-template-columns: 72px 1fr;
  align-items: center;
  gap: 8px;
}

.receive-label {
  font-size: 12px;
  color: var(--text-secondary);
}

.receive-value {
  font-size: 12px;
  color: var(--text-primary);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.receive-material-value {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  white-space: nowrap;
  flex-wrap: wrap;
}

.receive-material-no {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multi-version-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  color: #b45309;
  background: rgba(245, 158, 11, 0.16);
}

.version-edit-btn {
  flex-shrink: 0;
  height: 22px !important;
  padding: 0 8px !important;
  font-size: 11px !important;
}

.detail-material-no {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.detail-material-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.version-select-modal {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.version-select-modal .modal-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.version-parent-info {
  padding: 10px 12px;
  margin-bottom: 10px;
  border-radius: 10px;
  background: rgba(35, 177, 192, 0.1);
  border: 1px solid var(--border-color);
}

.version-parent-no {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}

.version-parent-desc {
  margin-top: 4px;
  font-size: 12px;
  color: var(--text-secondary);
}

.version-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.version-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--card-background);
  text-align: left;
  cursor: pointer;
}

.version-item.selected {
  border-color: var(--primary-color);
  background: rgba(35, 177, 192, 0.12);
}

.version-item-main {
  flex: 1;
  min-width: 0;
}

.version-item-no {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  word-break: break-all;
}

.version-item-desc {
  margin-top: 4px;
  font-size: 12px;
  color: var(--text-secondary);
  word-break: break-all;
}

.version-radio {
  flex-shrink: 0;
  accent-color: var(--primary-color);
}

.receive-fail-field {
  align-items: start;
}

.receive-fail-value {
  color: var(--danger-color, var(--error-color));
  background: rgba(239, 68, 68, 0.08);
  border-left: 3px solid var(--danger-color, var(--error-color));
  padding: 4px 6px;
  border-radius: 4px;
  display: block;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-all;
  line-height: 1.4;
  font-size: 12px;
}

.receive-fail-value.truncated {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.fail-desc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.fail-desc-toggle {
  font-size: 11px;
  color: var(--danger-color, #dc2626);
  transition: transform 0.2s;
}

.fail-desc-toggle.expanded {
  transform: rotate(180deg);
}

.receive-btn-group {
  display: flex;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
}

.receive-btn-group :deep(.el-button) {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  padding: 8px 4px;
  margin-left: 0 !important;
  border-radius: 8px !important;
  opacity: 0.85;
}

.receive-btn-group :deep(.el-button.is-multi-version-disabled) {
  opacity: 0.45;
  cursor: not-allowed;
  color: var(--el-button-disabled-text-color, #a8abb2);
  background-color: var(--el-button-disabled-bg-color, #f5f7fa);
  border-color: var(--el-button-disabled-border-color, #e4e7ed);
}

.receive-btn-group :deep(.el-button--primary) {
  --el-button-bg-color: #5bc0de;
  --el-button-border-color: #5bc0de;
  --el-button-hover-bg-color: #46b5d5;
  --el-button-hover-border-color: #46b5d5;
}

.receive-btn-group :deep(.el-button--warning) {
  --el-button-bg-color: #f0ad4e;
  --el-button-border-color: #f0ad4e;
  --el-button-hover-bg-color: #ec971f;
  --el-button-hover-border-color: #ec971f;
}

.detail-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 2000;
}

.detail-sheet {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  inset: 0;
  background: var(--background-color);
  display: flex;
  flex-direction: column;
}

.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  padding-top: calc(10px + env(safe-area-inset-top));
  background-color: var(--header-background);
  color: var(--header-text);
  box-shadow: 0 2px 8px rgba(35, 177, 192, 0.18);
}

.detail-back {
  border: none;
  background: transparent;
  padding: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-back-icon {
  width: 20px;
  height: 20px;
}

.detail-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--header-text);
}

.detail-header-right {
  width: 36px;
  height: 36px;
}

.detail-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 10px 10px 80px;
  -webkit-overflow-scrolling: touch;
}

.detail-loading,
.detail-error {
  background: var(--card-background);
  border-radius: 10px;
  padding: 12px;
  font-size: 13px;
  color: var(--text-primary);
  text-align: center;
}

.detail-section {
  background: var(--card-background);
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 8px var(--shadow-light);
  border: 1px solid var(--border-color);
}

.detail-section + .detail-section-title {
  margin-top: 8px;
}

.detail-section-title {
  margin-top: 8px;
  background: var(--card-background);
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.detail-row {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid var(--border-color);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  color: var(--text-secondary);
  font-size: 12px;
}

.detail-value {
  color: var(--text-primary);
  font-size: 12px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.detail-actions .light-btn.is-multi-version-disabled {
  opacity: 0.45;
  cursor: not-allowed;
  --el-button-bg-color: #c0c4cc !important;
  --el-button-border-color: #c0c4cc !important;
  --el-button-hover-bg-color: #c0c4cc !important;
  --el-button-hover-border-color: #c0c4cc !important;
}

.detail-empty {
  color: var(--text-light);
  font-size: 12px;
  padding: 8px 0;
  text-align: center;
}

.detail-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 12px 14px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: var(--background-color);
}

.detail-footer .detail-finish-btn {
  width: 100%;
  height: 42px;
  border-radius: 10px !important;
  --el-button-bg-color: #5bc0de;
  --el-button-border-color: #5bc0de;
  --el-button-hover-bg-color: #46b5d5;
  --el-button-hover-border-color: #46b5d5;
}

.action-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.25);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-overlay-panel {
  background: var(--card-background);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.action-overlay-text {
  font-size: 13px;
  color: var(--text-primary);
  font-weight: 600;
}

.scan-success-hint {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 210;
  padding: 8px 14px;
  background: var(--card-background);
  border-radius: 8px;
  color: #10b981;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 8px 20px var(--shadow-light);
}

.collect-error-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.35);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.collect-error-panel {
  width: 100%;
  max-width: 300px;
  background: var(--card-background);
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 12px 24px var(--shadow-light);
}

.collect-error-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
}

.collect-error-msg {
  margin-top: 8px;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.4;
  word-break: break-all;
}

.collect-error-btn {
  margin-top: 12px;
  width: 100%;
  border-radius: 10px !important;
  --el-button-bg-color: #5bc0de;
  --el-button-border-color: #5bc0de;
}

.collapse-row {
  margin-top: 8px;
  background: var(--card-background);
  border-radius: 10px;
  padding: 8px 10px;
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--text-secondary);
  font-size: 12px;
}

.pallet-info {
  margin-top: 8px;
  background: var(--card-background);
  border-radius: 10px;
  padding: 8px 10px;
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pallet-info-text {
  color: var(--text-primary);
  font-size: 12px;
}

.pallet-info-red {
  color: #ef4444;
  font-weight: 700;
}

.pallet-leftover-btn {
  border: none;
  background: var(--primary-color);
  color: #ffffff;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  flex: 0 0 auto;
}

.pallet-actions {
  margin-top: 8px;
  background: var(--card-background);
  border-radius: 10px;
  padding: 10px;
  border: 1px solid var(--border-color);
}

.pallet-file {
  display: none;
}

.scan-hidden {
  position: fixed;
  left: -9999px;
  top: -9999px;
  width: 320px;
  height: 320px;
  overflow: hidden;
}

.pallet-scan-error {
  margin-top: 8px;
  color: #ef4444;
  font-size: 11px;
}

.pallet-remaining-hint {
  margin-top: 8px;
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #f59e0b;
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 700;
}

.pallet-remaining-hint.done {
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.3);
  color: #10b981;
}

.pallet-remaining-num {
  font-size: 13px;
  font-weight: 800;
}

.pallet-input-row {
  display: grid;
  grid-template-columns: 1fr 90px;
  gap: 8px;
  align-items: center;
}

.pallet-code-wrap {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.pallet-code-select {
  flex: 1;
  min-width: 0;
}

.pallet-code-select :deep(.el-select__wrapper) {
  min-height: 38px;
}

.pallet-input-row .scan-btn {
  flex-shrink: 0;
  padding: 0;
  height: 38px;
  width: 36px;
  color: var(--primary-color);
}

.pallet-input-row .scan-btn:hover {
  color: var(--primary-color);
}

.pallet-qty-input {
  width: 90px;
}

.pallet-btn-row {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.pallet-btn-row :deep(.el-button) {
  font-size: 12px;
  padding: 8px 4px;
}

.pallet-list {
  margin-top: 8px;
  background: var(--card-background);
  border-radius: 10px;
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.pallet-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6px;
  align-items: center;
  padding: 8px 10px;
  border-bottom: 1px solid var(--border-color);
  white-space: nowrap;
}

.pallet-row:last-child {
  border-bottom: none;
}

.pallet-row-head {
  background: var(--background-color);
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 6px 10px;
  white-space: nowrap;
}

.pallet-col-code {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pallet-col-qty {
  text-align: right;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 600;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  white-space: nowrap;
}

.pallet-row-head .pallet-col-qty {
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 700;
}

.pallet-col-op {
  text-align: center;
  white-space: nowrap;
}

.pallet-item-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--text-primary);
}

.pallet-status-done {
  color: #10b981;
  font-weight: 600;
  font-size: 11px;
}

.pallet-status-pending {
  color: #f59e0b;
  font-weight: 600;
  font-size: 11px;
}

.pallet-radio {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 10px;
  color: transparent;
  background: var(--card-background);
  box-sizing: border-box;
}

.pallet-radio.checked {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: #ffffff;
  font-weight: 700;
}

.camera-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 2600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.camera-sheet {
  width: 100%;
  max-width: 480px;
  background: #0b1220;
  border-radius: 12px;
  overflow: hidden;
}

.camera-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  color: #ffffff;
}

.camera-title {
  font-size: 13px;
  font-weight: 800;
}

.camera-close {
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 700;
}

.camera-video {
  width: 100%;
  height: 280px;
  object-fit: cover;
  background: #000000;
}

.camera-tip {
  padding: 8px 10px 10px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}

.camera-error {
  padding: 0 10px 10px;
  color: #fecaca;
  font-size: 11px;
}

.camera-actions {
  padding: 0 10px 10px;
  display: flex;
  justify-content: flex-end;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 0 14px;
  box-sizing: border-box;
}

.ware-modal {
  width: 100%;
  max-width: 440px;
  background: var(--card-background);
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  box-sizing: border-box;
}

.ware-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 10px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.ware-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.ware-modal-close {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 14px;
  background: var(--background-color);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  cursor: pointer;
}

.ware-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.ware-modal-footer {
  padding: 10px 14px 14px;
  border-top: 1px solid var(--border-color);
  flex-shrink: 0;
}

.ware-modal-close-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  border-radius: 10px !important;
  --el-button-bg-color: #5bc0de;
  --el-button-border-color: #5bc0de;
}

.ware-table-container {
  width: 100%;
  overflow-x: auto;
}

.ware-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.ware-table thead {
  background: var(--background-color);
}

.ware-table th {
  padding: 8px 12px;
  text-align: center;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
  white-space: nowrap;
}

.ware-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-color);
  text-align: center;
}

.ware-tr:last-child td {
  border-bottom: none;
}

.ware-tr-occupied {
  background: rgba(232, 240, 254, 0.5);
}

.ware-tr-free {
  background: rgba(200, 230, 201, 0.5);
}

.ware-td-name {
  color: var(--text-primary);
  font-weight: 500;
}

.ware-td-occupied {
  font-weight: 500;
}

.ware-tr-occupied .ware-td-occupied {
  color: #1976d2;
}

.ware-tr:not(.ware-tr-occupied) .ware-td-occupied {
  color: #66bb6a;
}

.ware-td-stock {
  color: var(--brand-color);
  font-weight: 600;
}

.modal-container {
  width: 100%;
  max-width: 440px;
  background: var(--card-background);
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 96vh;
  box-sizing: border-box;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 10px;
  border-bottom: 1px solid var(--border-color);
}

.modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.modal-close {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 14px;
  background: var(--background-color);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body {
  padding: 0;
  overflow-y: auto;
}

.modal-footer {
  padding: 10px 14px 14px;
  border-top: 1px solid var(--border-color);
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.form-block {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 8px;
}

.form-group {
  position: relative;
}

.form-block.disabled {
  opacity: 0.6;
}

.block-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 6px;
}

.block-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.search-input {
  width: 100%;
  font-size: 13px;
  box-sizing: border-box;
}

.supplier-search-row {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  position: relative;
}

.supplier-search-select {
  width: auto;
}

.supplier-search-select :deep(.el-select__wrapper) {
  border-radius: 0;
  border-left: none;
  height: 36px;
}

.supplier-search-select :deep(.el-select__wrapper.is-focus) {
  box-shadow: none;
}

.supplier-search-select :deep(.el-select__inner) {
  height: 36px;
  line-height: 36px;
}

.type-filter-wrap {
  flex: 0 0 auto;
  display: inline-block;
  width: auto;
  max-width: max-content;
}

.sort-filter-wrap {
  flex: 0 0 auto;
  display: inline-block;
  width: auto;
  max-width: max-content;
}

.sort-filter-select {
  width: auto;
}

.sort-filter-select :deep(.el-select__wrapper) {
  border-radius: 8px 0 0 8px;
  height: 36px;
}

.sort-filter-select :deep(.el-select__wrapper.is-focus) {
  box-shadow: none;
}

.sort-filter-select :deep(.el-select__inner) {
  height: 36px;
  line-height: 36px;
}

.sort-filter-select :deep(.el-select__selected-item) {
  max-width: 4.5em;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* tooltip 触发器不参与拉伸，避免把排序框撑宽 */
.supplier-search-row > .el-tooltip__trigger,
.supplier-search-row > [class*="el-tooltip"] {
  flex: 0 0 auto;
  width: auto;
  max-width: max-content;
}

.supplier-search-input {
  flex: 1;
}

.supplier-search-input :deep(.el-select__wrapper) {
  border-radius: 0 8px 8px 0;
  border-left: none;
  height: 36px;
}

.supplier-search-input :deep(.el-select__wrapper.is-focus) {
  box-shadow: none;
}

.supplier-search-input :deep(.el-select__inner) {
  height: 36px;
  line-height: 36px;
}

.no-search {
  margin-bottom: 8px;
}

.no-search-row {
  display: flex;
  align-items: center;
}

.no-search-type-wrap {
  flex: 0 0 auto;
  display: inline-block;
  width: auto;
  max-width: max-content;
}

.no-search-select {
  width: auto;
}

.no-search-select :deep(.el-select__wrapper) {
  border-radius: 8px 0 0 8px;
  height: 36px;
}

.no-search-select :deep(.el-select__wrapper.is-focus) {
  box-shadow: none;
}

.no-search-select :deep(.el-select__inner) {
  height: 36px;
  line-height: 36px;
}

.no-search-input {
  flex: 1;
}

.no-search-input :deep(.el-input__wrapper) {
  border-radius: 0 8px 8px 0;
  border-left: none;
  height: 36px;
}

.no-search-input :deep(.el-input__inner) {
  height: 36px;
  line-height: 36px;
}

.no-search-hint {
  margin-top: 4px;
  font-size: 11px;
  color: var(--primary-color);
  font-weight: 500;
}

.modal-list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #f1f1f1;
  font-size: 11px;
  color: #718096;
}

.modal-list {
  display: flex;
  flex-direction: column;
}

.modal-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-color);
}

.modal-item-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-item-no {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  font-size: 12px;
}

.modal-item-checkbox {
  width: 20px;
  flex-shrink: 0;
}

.modal-item-stock-inline {
  flex: 0 0 auto;
  font-size: 11px;
  color: var(--text-primary);
}

.modal-item-main {
  min-width: 0;
  flex: 1 1 auto;
}

.dropdown-menu {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  margin-top: 4px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid var(--border-color);
  background: var(--card-background);
  overflow: hidden;
  max-height: 240px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 50;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-item {
  padding: 10px 14px;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dropdown-item + .dropdown-item {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.dropdown-item:hover {
  background: rgba(35, 177, 192, 0.06);
}

.dropdown-item:active {
  background: rgba(35, 177, 192, 0.12);
}

.dropdown-loading {
  padding: 14px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 12px;
}

.dropdown-empty {
  padding: 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 12px;
}

.empty-selected {
  padding: 8px 0;
  text-align: center;
}

.empty-selected-text {
  font-size: 12px;
  color: var(--text-secondary);
}

.selected-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.selected-card {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
}

.selected-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  background: var(--background-color);
}

.selected-card-body {
  padding: 6px 8px;
}

.selected-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 3px 0;
  font-size: 12px;
}

.selected-row-double {
  align-items: flex-start;
}

.selected-col {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  text-align: center;
}

.selected-row-double .value {
  text-align: center;
}

.label {
  color: var(--text-primary);
  flex: 0 0 auto;
  min-width: 64px;
}

.label.required {
  color: #ef4444;
}

.value {
  color: var(--text-primary);
  text-align: right;
  flex: 1 1 auto;
}

.mono {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
}

.material-modal {
  max-height: 94vh;
  max-width: 400px;
}

.material-modal-body {
  padding: 10px;
  flex: 1 1 auto;
}

.material-modal-footer {
  flex-direction: column;
  gap: 8px;
  padding: 8px 14px 14px;
}

.material-modal-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid var(--border-color);
}

.mini-page {
  font-size: 11px;
  color: var(--text-secondary);
}

.material-modal-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

#pallet-scan-region {
  display: flex;
  align-items: center;
  justify-content: center;
}

#pallet-scan-region :deep(video) {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-spinner {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 3px solid rgba(35, 177, 192, 0.2);
  border-top-color: var(--primary-color);
  animation: spin 0.9s linear infinite;
}

.loading-text {
  margin-top: 8px;
  color: var(--text-secondary);
  font-size: 12px;
}

.loading-state {
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state {
  margin-top: 20px;
  background: var(--card-background);
  border-radius: 12px;
  padding: 32px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 10px var(--shadow-light);
}

.empty-img {
  width: 100px;
  height: 100px;
  opacity: 0.95;
}

.empty-text {
  margin-top: 10px;
  color: var(--text-secondary);
  font-size: 13px;
}

.card-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.data-card {
  background: var(--card-background);
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 2px 10px var(--shadow-light);
  border: 1px solid var(--border-color);
  position: relative;
}

.card-remove-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid var(--border-color);
  background: var(--background-color);
  color: var(--text-secondary);
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.card-remove-btn:disabled {
  opacity: 0.6;
}

.list-footer {
  margin-top: 4px;
  background: var(--card-background);
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 2px 10px var(--shadow-light);
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.page-info {
  color: var(--text-secondary);
  font-size: 11px;
  flex: 1;
  min-width: 0;
}

.page-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.page-actions :deep(.el-button) {
  margin: 0;
}

.message-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.message-modal {
  background: var(--card-background);
  border-radius: 12px;
  padding: 24px 20px;
  margin: 0 20px;
  min-width: 240px;
  max-width: 300px;
  text-align: center;
}

.message-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto 12px;
}

.message-icon.info {
  background: #e3f2fd;
  color: #1976d2;
}

.message-icon.success {
  background: #e8f5e9;
  color: #4caf50;
}

.message-icon.error {
  background: #ffebee;
  color: #f44336;
}

.message-text {
  font-size: 14px;
  color: var(--text-primary);
  line-height: 1.5;
  margin-bottom: 20px;
}

.message-btn {
  width: 100%;
  border-radius: 10px !important;
  --el-button-bg-color: #5bc0de;
  --el-button-border-color: #5bc0de;
}

.card-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-right: 6px;
  flex-shrink: 0;
}

.card-checkbox:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.batch-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: var(--card-background);
  border-radius: 14px 14px 0 0;
  box-shadow: 0 -2px 10px var(--shadow-light);
  border: 1px solid var(--border-color);
  border-bottom: none;
  z-index: 100;
  gap: 8px;
}

.batch-select-info {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
  cursor: pointer;
}

.summary-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  align-items: flex-end;
}

.summary-sheet {
  width: 100%;
  max-height: 70vh;
  background: var(--card-background);
  border-radius: 14px 14px 0 0;
  display: flex;
  flex-direction: column;
}

.summary-header {
  display: flex;
  align-items: center;
  padding: 14px 12px;
  border-bottom: 1px solid var(--border-color);
  gap: 10px;
}

.summary-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1;
}

.summary-total-qty {
  font-size: 13px;
  font-weight: 600;
  color: var(--primary-color);
}

.summary-close {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  font-size: 20px;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.summary-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.summary-empty {
  text-align: center;
  color: var(--text-secondary);
  padding: 30px 0;
}

.summary-list {
  background: var(--background-color);
  border-radius: 10px;
  overflow: hidden;
}

.summary-row {
  display: grid;
  grid-template-columns: 1fr 70px;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-color);
}

.summary-row:last-child {
  border-bottom: none;
}

.summary-row-head {
  background: var(--card-background);
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
}

.summary-col-material {
  font-size: 12px;
  color: var(--text-primary);
  font-family: monospace;
}

.summary-col-qty {
  font-size: 12px;
  color: var(--primary-color);
  font-weight: 600;
  text-align: right;
}

.summary-footer {
  padding: 10px 12px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--border-color);
}

.summary-confirm-btn {
  width: 100%;
  border-radius: 10px !important;
  --el-button-bg-color: #5bc0de;
  --el-button-border-color: #5bc0de;
}

.status-banner {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 12px;
}

.status-banner.info {
  background: rgba(35, 177, 192, 0.12);
  color: var(--primary-color);
}

.status-banner.error {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

@media (max-height: 640px) {
  .camera-video {
    height: 200px;
  }

  #pallet-scan-region :deep(video) {
    height: 200px;
  }
}

#pallet-scan-region :deep(canvas) {
  width: 100% !important;
  height: auto !important;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<style>
.version-confirm-box {
  z-index: 5000 !important;
}
.el-overlay.version-confirm-box,
.el-message-box__wrapper {
  z-index: 5000 !important;
}
</style>
